<template>
  <div class="block roll">
    <div class="title">{{$t("scripture.title")}}</div>
    <div class="data_box">
      <div class="shell">
        <div class="box" v-for="(item, i) in textList" :key="i">
          <div class="number">{{i}}</div>
          <div class="title">{{item.title}}</div>
          <div class="in_title">{{item.title}}
            <span @click="notes(item)" class="notes">
              <i class="el-icon-warning"></i> {{$t("scripture.translate")}}</span>
          </div>
          <div class="text roll" v-html="item.text">
          </div>

        </div>
      </div>
    </div>

    <!-- ----------- -->
    <el-dialog :fullscreen="true" :title="nowNote.title" :visible.sync="dialogShow" width="95%" :before-close="clsoeNote" center>
      <div class="nodeBox" ref="nodeRef">
        <div class="textBox">
          <div class="text roll" v-html="nowNote.text"></div>
        </div>
        <div class="node">
          <div class="nodeTitle">【{{$t("scripture.translate")}}】</div>
          <div class="nodeText roll" v-html="nowNote.note"></div>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="dialogShow = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  name: "",
  data() {
    return {
      textList: [
        {
          title: "香赞",
          text: `<p>炉香乍爇，法界蒙薰。</p>
          <p>诸天圣境悉遥闻，随处结祥云。</p>
          <p>诚意方殷，列圣尽来巡。</p>
          <p>皈命</p>
          <p>香云浮盖大天尊</p>
           <p>——念诵三遍</p>`,
          note: `
           
            <p><b>⑴ 香赞：</b>敬香赞美词。○赞：称颂、赞美。香赞乃是借用佛经中的常用炉香赞。</p>
            <p><b>⑵ 炉香乍爇，法界蒙薰：</b>炉中的香刚开始点燃，十方一切世界就已经薰着了香气。○炉香：烧在炉里的香。○乍：刚，初。○爇（ruò）：烧，点燃。○法界：佛教中谓宇宙森罗万象的一切境界、全宇宙。○蒙：受着。薰：香气、香味。</p>
            <p><b>⑶ 诸天圣境悉遥闻。</b>众神所居的天界、仙境，都远远地闻到了这香气。○诸天：佛教中指护法众天神，这里是泛指天界。○圣境：超凡入圣的境界，借指仙界。○悉：完全。○遥闻：远远地嗅到。</p>
            <p><b>⑷ 随处结祥云：</b>香烟升腾在空中，结成了吉祥的云朵。○随处：处处。</p>
            <p><b>⑸ 诚意方殷，列圣尽来巡：</b>至诚恭敬的心意，虽然是刚刚殷勤地发出来，却能够感动列位神圣都下来巡察。○诚意：真心、恳切的意根。○方：刚刚。○殷：殷勤。○列圣：众神圣。○巡：巡察。</p>
            <p><b>⑹ 皈命——香云浮盖大天尊：</b>皈心啊，香烟祥云如宝盖，献给最尊贵的元始天尊。○皈命：皈心。○香云浮盖：借用佛教中“香云盖”典故，谓香炉里的香烟，腾在十方诸佛世界的虚空里头，结成像云一样的宝盖。佛教《金光明经》中说：一位人间的国王，一心恭敬听法师说《金光明经》，手里头拿着烧香的炉，供养这《金光明经》，只要在转一个念头的时候，那种香气已经散到了十方无量无边的诸佛世界去了。就在这无量诸佛世界的虚空里头，结成了香烟云的宝盖，发出一种金色的光来，周遍照到一切的世界；十方的诸佛就一齐赞叹这说法的法师，称他为大士（菩萨），说他将来一定成佛，这就是香云盖菩萨典故。○大天尊：道教对所奉天神中最尊贵者的尊称，通常指最高尊神元始天尊。</p>
          `,
        },
        {
          title: "净心神咒",
          text: `
         <p>太上台星，应变无停。</p>
         <p>驱邪缚魅，保命护身。</p>
         <p>智慧明净，心神安宁。</p>
         <p>三魂永久，魄无丧倾。</p>
         <p>急急如律令！</p>
        `,
          note: `
         【译注】
          <p><b>⑴ 净心神咒：</b>道教法事活动中常用的神咒之一。主要用于早坛功课、道场法事及学练符法咒语。念诵此咒，能起到净化身心、排除杂念干扰、安宁心神等作用。同时，亦有助于修炼之人作入静功夫。○神咒：道教指天神富有神通法力的秘语。咒，祝告之意，道教认为咒乃天神所颁，得之者可以役使鬼神。</p>
          <p><b>⑵ 太上台星，应变无停：</b>意为道教最高之神“太上”(道)无所不在，且一直处于运动中，在观察着世间万事万物的变化。○太上：本意是最上，道教演绎为“三清”尊神之一，居太清真境，名道德天尊，尊为教主。○台星：即北斗星之三台星，又称“三衡”。三台星君中的“上台”为虚精开德星君、“中台”为六淳司空星君、“下台”为曲生司禄星君。 三台上拱紫薇，中和阴阳而理万物，下承万星神众，为众星之尊。</p>
          <p><b>⑶ 驱邪缚魅，保命护身：</b>意指“太上”（道）随声感应，无处不在，邪魅鬼魃皆被驱离，修道之人的身心性命就能得到护佑。○邪、魅：泛指邪恶的事物。</p>
          <p><b>⑷ 智慧明净，心神安宁：</b>意为念诵此咒，能使人智慧开明，灵台明净，而得心神安宁。○智慧：指对事物的认识辨析、判断处理和发明创造等能力。○明净：心地清明而纯净，没有杂念。</p>
          <p><b>⑸ 三魂永久，魄无丧倾：</b>意指修道之人可以使“三魂”永固，“七魄”安然，元神永葆。○三魂：《云笈七签》说：“人有三魂，一名胎光，二名爽灵，三名幽精。胎光主生命，爽灵主财禄，幽精主灾衰。”○七魄：《云笈七签》云：“魄有七魄，分别为尸拘、伏矢、雀阴、吞贼、非毒、除秽、臭肺。”道书中认为人身上有“三魂七魄”，故常以“三魂”或“七魄”作魂魄的总称。○丧倾：丧失倾堕。</p>
          <p><b>⑹ 急急如律令：</b>意为天神颁敕，须按号令火急奉行，不得延误。○急急：原意是紧急、急速之意。○如律令：即如律敕之令，本为汉代公文用语，表示公文一到，要像对待律令一样加以执行。道教作法事和炼符法时常移用于符咒之末，意思是火速遵令而行。</p>
         `,
        },
        {
          title: "净口神咒",
          text: `
       <p>丹朱口神，吐秽除氛。</p>
       <p>舌神正伦，通命养神。</p>
       <p>罗千齿神，却邪卫真。</p>
       <p>喉神虎贲，气神引津。</p>
       <p>心神丹元，令我通真。</p>
       <p>思神炼液，道炁常存。</p>
       <p>急急如律令！</p>
        `,
          note: `
        
          <p><b>⑴ 净口神咒：</b>道教法事活动常用神咒之一。念诵此咒，意在清净口舌，使口部诸神归位，消除口业（如妄言），涤除浊气（如腥膻），以清洁之口诵念经文。</p>
          <p><b>⑵ 丹朱口神，吐秽除氛：</b>意为召唤口神丹朱，来吐除口中浊秽之气，吸纳清新之气。○丹朱：据《黄庭内景真经》云“口神为丹朱”。○吐秽除氛：口吐污浊之气，鼻引清新之气，即吐故纳新。</p>
          <p><b>⑶ 舌神正伦，通命养神：</b>意为召唤舌神正伦，来司声咽津，通宿命以养元神。○舌神正伦：据《黄庭内景经·至道章》云：“舌神通命字正伦。”因为舌头能司声咽津，性命得通，能正其五味，而各有伦序，故称正伦。○通命养神：通宿命，静养元神。能通命者保精也，养神者以炼性也，含性命双修之意。</p>
          <p><b>⑷ 罗千齿神，却邪卫真：</b>意为召唤齿神罗千，使邪魅不能侵犯，真神得到护卫。○罗千齿神：据《黄庭内景经·至道章》云：“齿神锷峰字罗千。”○却邪卫真：去除邪祟，护卫身心。</p>
          <p><b>⑸ 喉神虎贲，炁神引津：</b>意为召唤喉神虎贲，而炁神修炼之时要生津聚精，使神、气、津配合一体。○喉神：即虎贲。○炁神：可引津。炁，同“气”。又《黄庭内景经》谓唾液为“金津玉液”，简称“津”。</p>
          <p><b>⑹ 心神丹元，令我通真：</b>意为心内元神为丹元，抱元守之，凝结成丹，即能使我“通真”。○心神丹元：按《黄庭内景经·心神章》云：“心为五脏之元宰，属火而色赤。”○通真：通达玄真。玄真，道教对“道”境的称谓，又名妙真。意为玄不可知，妙不可言的境界。</p>
          <p><b>⑺ 思神炼液，道炁常存：</b>意为保存好思神，修炼出金津玉液，则可与道合真，长生不老。○思神：指存神。○炼液：指修炼好金津玉液（口液）。○道炁常存：即通过不断修炼，使自己与道合真，长保超凡脱俗的气质。○道炁（气）：道教用语，本指道与气，宇宙化生的本源。</p>
`,
        },
        {
          title: "净身神咒",
          text: `
          <p>灵宝天尊，安慰身形。</p>
          <p>弟子魂魄，五脏玄冥。</p>
          <p>青龙白虎，队仗纷纭。</p>
          <p>朱雀玄武，侍卫我身。</p>
          <p>急急如律令！</p>
        `,
          note: `
       
         <p><b>⑴ 净身神咒：</b>道教法事活动中常用神咒之一。谓念诵此咒能使人身部诸神归位，以洁净身体感召神灵。</p>
         <p><b>⑵ 灵宝天尊，安慰身形：</b>意指心存灵宝天尊，守定心神，以使身形安稳。○灵宝天尊：即道教“三清” 第二尊神，居三清境之上清真境。意谓念诵此咒时要万法俱忘，心神合一，方能神宁泰定。○安慰：静养抚慰。</p>
         <p><b>⑶ 弟子魂魄，五脏玄冥：</b>意指学道弟子要守镇魂魄，修炼衍养护好自己的五脏。○弟子：指学道之人，一作“法子”。○魂魄：按《淮南子》注云：“魂者阳之神，魄者阴之神。”○五脏：本指人身的心、肝、脾、肺、肾。○玄冥：玄深幽寂。</p>
         <p><b>⑷ 青龙白虎，队仗纷纭。朱雀玄武，侍卫我真：</b>意为五脏之气化为四种正神兽，即左青龙、右白虎、前朱雀、后玄武，四兽侍卫自身左右前后，来养护肝肺心肾。道教中人在修炼中谓白虎护肺属金，青龙护肝属木，朱雀护心属火，玄武护肾属水，依其法而炼之，可修成大道，证得道果。○青龙白虎：按《礼记·曲礼上》疏曰：“朱鸟、玄武、青龙、白虎，四方宿名也。”</p>
`,
        },
        {
          title: "安土地神咒",
          text: `
          <p>元始安镇，普告万灵。</p>
          <p>岳渎真官，土地祇灵。</p>
          <p>左社右稷，不得妄惊。</p>
          <p>回向正道，内外澄清。</p>
          <p>各安方位，备守家庭。</p>
          <p>太上有命，搜捕邪精。</p>
          <p>护法神王，保卫诵经。</p>
          <p>皈依大道，元亨利贞。</p>
          <p>急急如律令！</p>
        `,
          note: `
       
      <p><b>⑴ 安土地神咒：<b>道教法事活动中常用神咒之一。一般是道教徒在结坛、上殿或外出做法事时所诵。意在使当境岳渎土地之神各安方位，备守坛场，护卫诵经活动。</p>
      <p><b>⑵ 元始安镇，普告万灵：</b>意为元始天尊安镇于玉清圣境，全面告知天地四维十方一切神灵。○元始：道教三清尊神之一，号“玉清元始天尊”，居玉清圣境。○安镇：平静坐镇。○普告：全面宣告。○万灵：指天地十方之众神。</p>
      <p><b>⑶ 岳渎真官，土地祇灵：</b>镇守五岳四渎的仙官和管理土地的神祇们。○岳：五岳，指南岳衡山、中岳嵩山、北岳恒山、东岳泰山、西岳华山。○渎：四渎，指江（长江）、河（黄河）、淮、济。按：“岳渎”连用，也泛指名山大川。○土地祇灵：此指当境土地之众神灵仙家。</p>
      <p><b>⑷ 左社右稷，不得妄惊：</b>意指当境地神、谷神，不必惊慌，各守其职，以使道场法事顺利进行。○社：古时指祭祀土地神的地方，这里指当土之众神灵。○稷：本为古代一种粮食作物。古以稷为百谷之长。因此帝王奉祀为谷神。按：“社稷”连用，也代指国家。○妄：乱。○惊：惊慌。</p>
      <p><b>⑸ 回向正道，内外澄清：</b>意指此咒可使人身心内外似水之清，走向光明大道。○回向：此指回转趋向。○正道：正大光明的大道。○内：内心。○外：身体。○澄清，本指使水慢慢清亮。此指使心神慢慢安定。</p>
      <p><b>⑹ 各安方位，备守坛(家)庭：</b>意指众神灵依次回到自己的位置，尽力守卫祈祷法事的处所。○安：回到。○备：全部，尽。○守：守卫。○坛（家）庭：指道教作功课祈祷的场合。按：如是在信士、居士家中作法事，则诵作“备守家庭”；如是在戒坛作法事，则改诵为“备守律坛”。</p>
      <p><b>⑺ 太上有命，搜捕邪精：</b>意指太上发布敕令，搜寻捕捉一切邪精鬼怪，勿让其危害人间。○太上：指太上老君，道教中最高尊神。</p>
      <p><b>⑻ 护法神王，保卫诵经：</b>意指太上搜捕邪精后，将临坛讲经说法，护法神王均将降临，保卫左右，以顺利诵经。</p>
      <p><b>⑼ 皈依大道，元亨利贞：</b>意为土地神明行具君子之德，皈依太上无极大道，以到达创始、亨通、祥和、坚固的理想境界。○皈依：皈投依靠。○大道：太上无极大道。○元亨利贞：语出《易经·乾卦》：“元者，善之长也；亨者，嘉会也；利者，义之和也；贞者，事之干也。此为君子之四德。”南宋朱熹将此“四德”解释为万物从生长到成熟四个阶段：“物生为元，长为亨，成而未全为利，成熟为贞。”</p>
`,
        },
        {
          title: "净天地神咒",
          text: `
          <p>天地自然，秽气分散。</p>
          <p>洞中虚玄，晃朗太元。</p>
          <p>八方威神，使我自然。</p>
          <p>灵宝符命，普告九天。</p>
          <p>乾罗答那，洞罡太玄。</p>
          <p>斩妖缚邪，度人万千。</p>
          <p>中山神咒，元始玉文。</p>
          <p>持诵一遍，却病延年。</p>
          <p>按行五岳，八海知闻。</p>
          <p>魔王束首，侍卫我轩。</p>
          <p>凶秽荡尽，道炁长存。</p>
          <p>急急如律令！</p>
        `,
          note: `
         
        <p><b>⑴ 净天地神咒：</b>道教法事活动中常用神咒之一，主要用于上殿诵经、经坛施法时。意在扫除秽气。</p>
        <p><b>⑵ 天地自然，秽气分散：</b>意指在天地大自然中，常有不洁净之气分散其中。○秽：不洁净。</p>
        <p><b>⑶ 洞中玄虚，晃朗太元：</b>意指地上之洞空蒙深幽，而天上则明亮深远。○洞中：按洞阳子注：“洞者，通也。上通于民，下通于地，中有神仙。”○玄虚：空洞。○晃朗：光明貌。○太元：即太玄。汉扬雄《太玄经》：“玄者，天玄也、地玄也、人玄也。天浑行无穹不可见也，地不可形也，人心不可测也。故玄，深广远大矣。”</p>
        <p><b>⑷ 八方威神，使我自然：</b>意指指各路护法神王威力无穷，令我同天地自然浑然一体。○八方：四方四隅的总称。</p>
        <p><b>⑸ 灵宝符命，普告九天：</b>意指灵宝天尊发布命令，广泛地昭告于天界。○灵宝：灵宝天尊，道教三清尊神之一。○符命：本指上天预示帝王受命的符兆。○九天：按《淮南子·天文训》云：“天有九野，中央及四正四隅，故曰九天。”</p>
        <p><b>⑹ 乾罗答那，洞罡太玄：</b>意为召唤荡秽神将乾罗答那、洞罡太玄等神使速速降临。○乾罗答那：按《荡秽朝科》中，破五方厌秽时要焚香奉请“乾罗答那、洞罡太玄使者、斩妖缚邪神吏”。乾罗答那，亦写作“乾罗怛那”或“乾罗达那”，原是佛经中梵音咒语的音译。</p>
        <p><b>⑺ 斩妖缚邪，度人万千：</b>意为斩妖魔缚邪怪，普度众生万千人。○度人：一本作“杀鬼”。按道教戒律一般“不言杀”，故以用“度人”为佳。○万千：形容数量大。</p>
        <p><b>⑻ 中山神咒，元始玉文：</b>意为此咒可比紫庭真人的《中山神咒》，元始天尊的书符玉文。○中山神咒：道书中说是紫庭真人夏禹所作之咒语。《云笈七签》云：“夏禹于阳明洞天感太上命绣衣使者降，授《灵宝五符》以理水，檄召万神。后得道为太极紫庭真人，演出《大小劫经》、《中山神咒》、《八威召龙》等经，今行于世矣。”○元始玉文：元始天尊所说之经文。按道经中载元始天尊所说经有《元始五老赤书玉篇眞文天书经》，又名《赤书真文》，实际是五篇符咒文字。元始天尊，是道教最尊之神三清之一，居玉清圣境。玉文，道经文字的美称。</p>
        <p><b>⑼ 持诵一遍，却病延年：</b>意为修炼之人念诵一遍《元始玉文》，就可以除病延年。</p>
        <p><b>⑽ 按行五岳，八海知闻：</b>意指将元始玉文行持于五岳，传播于八海，无处不在无所不闻。○按行：巡行，巡视。○五岳：指东岳泰山、西岳华山、南岳衡山、北岳恒山、中岳嵩山。○八海：指四方四隅之海，泛指天下。</p>
        <p><b>⑾ 魔王束首，侍卫我轩：</b>意指神咒的威力，可以降服魔王鬼怪，护卫真仙。○魔王：指有奇异法术害人的鬼王。○束首：俯首，表示降服。○侍卫：跟随守卫。○轩：本意指古代一种带装饰的车。</p>
        <p><b>⑿ 凶秽消散，道炁常存：</b>意为常持诵元始玉文，魔障自然驱散，凶秽不存而道气常存也。○凶秽：指凶恶不吉不洁之气。○道炁：超凡入圣的气质。</p>
`,
        },
        {
          title: "金光神咒",
          text: `
          <p>天地玄宗，万炁本根。</p>
          <p>广修万劫，证吾神通。</p>
          <p>三界内外，惟道独尊。</p>
          <p>体有金光，覆映吾身。</p>
          <p>视之不见，听之不闻。</p>
          <p>包罗天地，养育群生。</p>
          <p>诵持万遍，身有光明。</p>
          <p>三界侍卫，五帝伺迎。</p>
          <p>万神朝礼，役使雷霆。</p>
          <p>鬼妖丧胆，精怪亡形。</p>
          <p>内有霹雳，雷神隐名。</p>
          <p>洞慧交彻，五炁腾腾。</p>
          <p>金光速现，覆护真人。</p>
          <p>急急如律令！</p>
        `,
          note: `
        
<p><b>⑴ 金光神咒：</b>道教法事活动中常用神咒之一，在道教科仪(特别是开光法会)中经常使用。“金光”，指元始和其他尊神的神光。咒，为祈金光映覆，赐予神通，雷法中视作祈祷和策役神将的咒语。</p>
<p><b>⑵ 天地玄宗，万炁本根：</b>意为天地间的万物均为阴阳合散所为，“道”是万事万物的根本。○玄宗：道的深奥旨意。○万炁：万气，天地万物。</p>
<p><b>⑶ 广修亿劫，证吾神通：</b>意指通过不断修持可战胜亿万劫难，神明的通灵亦可得到证明。○修：虔诚学习教义并付诸行动。○劫：劫数、劫难。○证：证明。○神通：神明通灵。</p>
<p><b>⑷ 三界内外，惟道独尊：</b>意为在天地三界的内外，只有“道”是最为尊荣崇高的。○三界：有多种说法。《云笈七签》云：“二十八天分为三界……第一欲界，第二色界，第三无色界。”又有分宇宙为无极界、太极界、现世界为“三界”的；还有以天界、地界、水界为“三界”的。道教认为人可通过修炼，跳出“三界”，成为神仙。</p>
<p><b>⑸ 体有金光，覆映吾身：</b>意为修炼中人按此法咒修持，到了一定程度则会得金光圆满,庇映于道体。○体：道体。道教认为大道本无形体，但道体蕴显金光,依人为体，则会发出金光。○金光：指炼得金丹的内外景象。北宋道教南宗初祖张伯端《悟真篇》：“近来透体金光现，不与凡人话此规。”清仇兆鳌《悟真篇》：“金光圆满，其状似规。”○覆：覆宥。○映：庇映。○吾身：修道者之身体。</p>
<p><b>⑹ 视之不见，听之不闻：</b>意指修炼中人炼到心静、听闻不觉的忘我程度。老子《道德经》曰：“视之不见名曰夷，听之不闻名曰希。”《功课经》：“视之不见，听之不闻，离种种边，名为妙道。”○视：用眼看。○见：看到。○听：用耳听。○闻：听到。</p>
<p><b>⑺ 包罗天地，养育群生：</b>意指大道虽无形无声，但它却涵盖天地，养育群生。○养育：孕生化育。○群生：人及众物。</p>
<p><b>⑻ 受持万遍，身有光明：</b>意指道教中人依照以上法咒不断地得到真仙的口传心授和不断行持，就会得到“身有光明”的效果。○受：古通“授”。○身：受持者之身。○光：金光。○明：昭著。</p>
<p><b>⑼ 三界侍卫，五帝司迎：</b>意为三界众圣俱来侍卫身旁，五老上帝也在天庭(三界)外候迎。○“三界：指天、地、人。三界还有多种含义，如指欲界、色界、无色界。又天地水三界,又宇宙之三界为无极、太极、有极，人之三界为精、气、神。○五帝：五老上帝、五老君。指“三清”之说还没成为主流之前地位最高的五位神仙，本来是历代帝王祭祀的对象，后来纳入道家的神仙体系，称其为“天中则称五老上帝，在天文则称五帝座及五方五星，在神灵则称五方五帝，在山岳则称五岳圣帝，在人身则称五脏神君”，又称其为五行之始、五气之祖。在道教神仙体系中，五老君没有具体职司，但地位崇尊。○司：司职。○迎：彼来此受，如主之迎宾也。按此指修者存道体之金光，三界上下，五老五帝都要迎候。</p>
<p><b>⑽ 万神朝礼，役使雷霆：</b>意指修炼得道之人体内众神朝会相聚，就如于天庭驱使五雷神使，无所不达。○万神：指诸天众神。○役使：差遣驱使。○雷霆：代指雷神。全句意谓经过不断的修炼，以达百神默朝修真之妙。</p>
<p><b>⑾ 邪妖丧胆，精怪忘形：</b>意指妖魔鬼怪见“万神朝礼，役使雷霆”，都为之丧胆，精灵鬼怪个个现出原形，不敢为非作歹。○邪妖：背道之徒。○丧胆：不敢肆也。按道教认为人身亦有鬼妖，道气存则万缘俱息，不啻失其胆也。○精怪：木精土怪。○忘形：失其真形也。此指声色货利，既入道则诸念不生，不啻忘其形也。修道者既证金光，则鬼魅邪祟丧胆而显露原形。</p>
<p><b>⑿ 内有霹雳，雷神隐名：</b>意指“鬼妖、精怪”闻得金光大法而远遁，雷神就隐于金光中而不名，为制约鬼怪，灭其形迹。○内：道体之内。○霹雳：雷声。此处形容金光大法的巨大威力。○雷神：先天一炁正神。○隐名：三十六尊雷神名讳隐藏。此言道虽尊严，性本自宁，雷神隐藏，摄伏精怪。按：道经中谓雷部有三十六雷神，称“玉枢雷、玉府雷、玉柱雷、上清洞雷、火轮雷、灌斗雷、风火雷”等等，司施云布雨、执行雷部惩罚恶人等任务。</p>
<p><b>⒀ 洞慧交彻，五炁腾腾：</b>意言通接慧光，相交映彻，天地之五行正气，融会交互，氤氲腾腾之光，迅速现于眼前。○洞慧：通慧、觉悟。慧，慧光。○交彻：交互贯彻。○五炁：金木水火土五行之气。炁，同“气”。○腾腾：形容五行正气升腾。</p>
<p><b>⒁ 金光速现，覆护真人：</b>意指修炼到一定程度之人，“神光”出现，护卫真人。○金光：神光。○速现：快速出现。○覆护：指金光遍体。○真人：求道者自称。</p>
`,
        },
        {
          title: "祝香咒",
          text: `
          <p>道由心洽，心假香传。</p>
          <p>香爇玉炉，心存圣前。</p>
          <p>真灵下盼，仙旆临轩。</p>
          <p>弟子关告，径达九天。</p>
        `,
          note: `
     
      <p><b>⑴ 祝香咒：</b>也称《发炉咒》，道教法事活动中常用神咒之一。此咒为道教徒在念诵《功课经》中，结坛施法及上香时所念，焚香为供养神灵常用。道教认为香烟缭绕成云篆，可以将悃诚之意传达仙境，故极为重视。上香前须祝之以使香烟传达其诚心。</p>
      <p><b>⑵ 道由心洽，心假香传：</b>意指“道”必须由修道者用诚心来融会，悃诚之心和愿望则可以凭借焚香来传达至仙境。○道：道教最高教理。○洽：谐和。一本作“学”，指学习。○假：凭借。</p>
      <p><b>⑶ 香爇玉炉，心存帝前：</b>意为修道之人不惟将所焚之香插于玉炉之中，更须在心里存思天帝真仙就在自己的面前。○爇（ruò）：烧，点燃。○心存：心里存思。○帝：指天帝和诸仙。</p>
      <p><b>⑷ 真灵下盼，仙旆临轩：</b>意指修道者的真心感动上圣高真，他们向下俯视，循着香烟，云拥旌幢，仙驾降临于法坛。○下盼：向下俯视。○旆：古代旗帜下端燕尾状的装饰物。此处指仙人队仗前导旗帜。</p>
      <p><b>⑸ 弟子关告，径达九天：</b>○弟子向上真祝告，希望将诚心意愿直达九天之上，仙圣之前。“弟子”一作“今（令）臣”，用于道长自称。○关告：禀告。○径达：直接达到。○九天：按《淮南子·天文训》：“天有九野，中央及四正四隅，故亦曰九天。”道经中指“三清”化生九天，乃神仙所居之处。</p>
`,
        },
        {
          title: "开经玄蕴咒",
          text: `
          <p>云篆太虚，浩劫之初。</p>
          <p>乍遐乍迩，或沉或浮。</p>
          <p>五方徘徊，一丈之余。</p>
          <p>天真皇人，按笔乃书。</p>
          <p>以演洞章，次书灵符。</p>
          <p>元始降下，真文诞敷。</p>
          <p>昭昭其有，冥冥其无。</p>
          <p>沉疴能自痊，尘劳溺可扶。</p>
          <p>幽冥将有赖，由是升仙都。</p>
        `,
          note: `
      
       <p><b>⑴ 开经玄蕴咒：</b>道教法事中常用神咒之一，又简称“玄蕴咒”，即准备翻开道经奉诵时所念。○玄蕴：蕴藏玄妙的义理。</p>
       <p><b>⑵ 云篆太虚，浩劫之初：</b>意为在漫长混沌劫运之初，元始自然之气结成了云书符篆。○云篆：形体如云的灵图符篆。《云笈七签》：“篆者，撰也，撰集云书谓之云篆。”又《三洞神符记》：“道教符篆文字形体如云，故名云篆。”○太虚：道教中称化生天地阶段，即天地形成化生万物阶段。《太上元宝金庭无为妙经·太虚章第一》：“道言无形合虚，中有万物，而行二仪，是谓太虚……太虚者，神运也，神运而万物生。”</p>
       <p><b>⑶ 乍遐乍迩，或沉或浮：</b>意为元始传告下界的云篆灵符在“太虚”之层忽远忽近，或沉或浮，不断地上下传播。○乍：忽然。○遐、迩：远、近。</p>
       <p><b>⑷ 五方徘徊，一丈之余：</b>意言元始告传下界的云篆灵文不断地在天地间出现，每字有一丈有余。○五方：指东南西北中。</p>
       <p><b>⑸ 天真皇人，按笔乃书：</b>意指此时出现了天真皇人，他开始执笔记载。○天真皇人：《历世真仙体道通鉴》为道教信奉的前劫修真获得极道的远古仙人，体貌诡异奇伟，身长九尺，且黑毛披体。轩辕黄帝时，曾隐迹峨嵋山。以苍玉筑室居于绝壁之下。室内座具皆黄金做成，侍者为仙童玉女。有泰清仙王三人陪坐。黄帝曾前往拜见问道，授之以“五牙三一之文”。后又于峨嵋山脚下再遇黄帝，授以《太上灵宝度人经》。后遇帝喾于牧德之台，又将《太上灵宝度人经》授与帝喾。</p>
       <p><b>⑹ 以演洞章，次书灵符：</b>以之来演示元始无量之洞章，然后书写成云篆灵符。○洞章：指道教经书。道教经书分洞真、洞玄、洞神三部，故称。</p>
       <p><b>⑺ 元始下降，真文诞敷：</b>意指此时元始天尊亲自下降，开始为下界敷讲真经。○真文：真经。○诞敷：遍布。</p>
       <p><b>⑻ 昭昭其有，冥冥其无：</b>意指元始演说之真经，含义深奥，心中明亮者大有收获，心中昏昏者一无所得。○昭昭：光明，明亮。○冥冥：昏暗。《荀子·劝学》：“无冥冥之志者，无昭昭之明。”</p>
       <p><b>⑼ 沉疴能自痊，尘劳溺可扶。幽冥将有赖,由是升仙都：</b>意指诚心诵念此经者，能使重病痊愈；多积功德，悔过自新，即使堕落深渊，亦如同有人扶持；在幽暗阴昏之地亦将有人搭救；真仙上圣护佑你升入仙都。○此四句长作开经偈语。○沉疴：重病。○尘劳：指堕落尘世。泛指为世俗事务所劳累。○溺：指沉溺，比喻沉迷其中，无法自拔。○仙都：犹仙乡，神仙居处。</p>
`,
        },
        {
          title: "迎圣歌",
          text: `
          <p>后自天降兮，湄之阳。</p>
          <p>坤元赞化兮，鸑鷟翔。</p>
          <p>驾虹掣电兮，云锦裳。</p>
          <p>海若先驱兮，蛟螭藏。</p>
          <p>耀沧溟兮，光焕天章。</p>
          <p>歌清晏兮，万国梯航。</p>
          <p>声坎坎兮，钟鼓铿锵。</p>
          <p>颂且祷兮，锡祉无疆。</p>
        `,
          note: `
    
     <p><b>⑴ 迎圣歌：</b>迎接天后圣母降临的颂歌。</p>
     <p><b>⑵ 后自天降兮，湄之阳：</b>天后自天庭诞降啊，来到湄洲山的南边。○阳：《春秋谷梁传·僖公二十八年》：“山南为阳,水北为阳。”</p>
     <p><b>⑶ 坤元赞化兮，鸑鷟翔：</b>像生长万物的大地辅助教化啊，凤凰随之翱翔。○鸑鷟（yuè zhuó）：传说为凤凰之一种，是祥瑞之鸟。</p>
     <p><b>⑷ 驾虹掣电兮，云锦裳：</b>神灵驾乘虹霓如闪电般前行啊，身着云霞样的衣裳。○掣：闪过。形容非常迅速。</p>
     <p><b>⑸ 海若先驱兮，蛟螭藏：</b>东海的海神海若作为銮驾先导啊，蛟龙水族们都一一避藏。</p>
     <p><b>⑹ 耀沧溟兮，光焕天章：</b>鸾舆神驾辉耀大海啊，光芒炳映天上的星光。○天章：犹天文。指分布在天空的日月星辰等。</p>
     <p><b>⑺ 歌清晏兮，万国梯航：</b>放声歌颂天下清平安定啊，万国臣服四海来航。○清晏：清平安宁。○梯航：梯与船，登山渡水的工具。亦为“梯山航海”的省语，谓历经险阻的长途跋涉。</p>
     <p><b>⑻ 声坎坎兮，钟鼓铿锵：</b>迎神的钟鼓声镗镗啊，钟声响亮鼓声激扬。○坎坎：形容鼓声、钟声。《诗经·小雅·伐木》：“坎坎鼓我，蹲蹲舞我。”○铿锵：形容声音响亮激越。</p>
     <p><b>⑼ 颂且祷兮，锡祉无疆：</b>万民颂赞且祈祷啊，圣母赐福地久天长。○锡：通“赐”。</p>
`,
        },
        {
          title: "天上圣母宝诰",
          text: `
          <p>志心皈命礼</p>
          <p>圣德参天，国家忠孝无双女。</p>
          <p>母恩配地，闽省功名第一人。</p>
          <p>通贤灵体，默静仙真。</p>
          <p>传古圣之道统，学先祖之慈仁。</p>
          <p>救苦救难，爱国爱民。</p>
          <p>大慈大悲，至节至贞。</p>
          <p>敕封天上圣母，玉封天后尊神。</p>
          <p>——念诵三遍</p>
        `,
          note: `
          
          <p><b>⑴ 天上圣母宝诰：</b>天上圣母妈祖的诰章。○宝诰：也称诰章，道教原指神仙传达圣意的一种韵文文体，后衍伸为赞颂神仙的骈文诗歌。宝诰首句，以“志心皈命礼”为开头，表示虔诚顶礼膜拜。宝诰最后多为诰封之神仙圣号。《说文》：“诰，告也。”后指自上而下的传达、命令。</p>
          <p><b>⑵ 志心皈命礼：</b>专心皈依顶礼膜拜。○志心：诚心。○皈命：皈心。</p>
          <p><b>⑶ 圣德参天，国家忠孝无双女：</b>天上圣母的大德高比苍天，她原是堪作家国模范的忠孝双全无双圣女。</p>
          <p><b>⑷ 母恩配地，闽省功名第一人：</b>天上圣母的洪恩厚比大地，其功业和声名在八闽大地堪称独一无二。</p>
          <p><b>⑸ 通贤灵体，默静仙真：</b>她有通达贤能的神奇身体，她是沉默清静的得道神仙。</p>
          <p><b>⑹ 传古圣之道统，学先祖之慈仁：</b>她承传古代圣贤的脉络系统，她效法祖先的慈善仁爱。</p>
          <p><b>⑺ 救苦救难，爱国爱民：</b>她拯救痛苦拯救危难，还爱护国家、爱护人民。</p>
          <p><b>⑻ 大慈大悲，至节至贞：</b>她具大慈心、大悲心，节义最高、意志最专。○慈：用爱护心给予众生以安乐。○悲：用怜悯心解除众生的痛苦。○节：节义。○贞：专一。</p>
          <p><b>⑼ 敕封天上圣母，玉封天后尊神：</b>人间皇帝封她为天上圣母，天上玉帝封她为天后尊神。○敕封：皇帝颁诏书封赐爵号。○玉封：天封，即玉帝所封。</p>
          `,
        },
        {
          title: "开经赞",
          text: `
          <p>湄洲毓秀，南海化身。</p>
          <p>大忠大孝，至圣至仁。</p>
          <p>宏慈说法利沉沦，寰海庆同春。</p>
          <p>灵应如神，普渡尔生人。</p>
        `,
          note: `
         
         <p><b>⑴ 开经赞：</b>准备开始诵经的赞诗。</p>
         <p><b>⑵ 湄洲毓秀，南海化身：</b>妈祖是湄洲养育出的拔萃人才，也是南海观音的下凡化身。</p>
         <p><b>⑶ 大忠大孝，至圣至仁：</b>妈祖平生对国家尽忠、对父母大孝，其聪智最高、仁德最大。</p>
         <p><b>⑷ 宏慈说法利沉沦，寰海庆同春：</b>大慈悲的说法利于拯救执迷不悟者，她的希望是四海共庆暖如春。</p>
         <p><b>⑸ 灵应如神，普渡尔生人：</b>妈祖经书灵验真如神，其法力将引导众生走出迷惘的渡口。○生人：生民，百姓。</p>
`,
        },
        {
          title: "湄洲天上圣母真经",
          text: `
          <p>建隆岁，宋开基。国一统，万民期。</p>
          <p>近悦服，远来归。天相佑，降圣妃。</p>
          <p>九牧祖，林蕴系。积善久，荫门第。</p>
          <p>林巡检，妻王氏。隐湄岛，诗书继。</p>
          <p>默娘儿，林家裔。有一兄，并五姊。</p>
          <p>幺女身，行居七。默娘生，大士示。</p>
          <p>湄洲诞，征象奇。土尽紫，香满闱。</p>
          <p>生弥月，不闻啼。读书敏，百事知。</p>
          <p>能达礼，能作诗。孝父母，守伦规。</p>
          <p>学圣道，遇明师。得秘诀，悟玄微。</p>
          <p>传神术，获灵机。窥古井，铜符持。</p>
          <p>海上游，初显异。救父兄，行孝悌。</p>
          <p>油成菜，生民食。欲渡海，无舟楫。</p>
          <p>遇风涛，挂草席。门夹港，暗礁磊。</p>
          <p>商船触，舱进水。小草掷，大木起。</p>
          <p>船得救，众口美。驱铁马，海上驰。</p>
          <p>不解鞍，不闻嘶。旱祷雨，民得济。</p>
          <p>悬菖蒲，救瘟疫。能驱蛟，勇除魅。</p>
          <p>伏晏公，法绳制。千里眼，顺风耳。</p>
          <p>本为精，金与水。演神咒，二精跪。</p>
          <p>收两将，作护卫。叩拜服，高里鬼。</p>
          <p>驱二孛，通津继。破二嘉，船安舣。</p>
          <p>收为将，功赎罪。锁双龙，霪雨止。</p>
          <p>岁丰盈，民大喜。弱女身，常舍己。</p>
          <p>救世法，出乡里。功满足，行成期。</p>
          <p>纯阳体，法身飞。恩泽大，天庭知。</p>
          <p>受帝召，不敢违。九月九，重阳时。</p>
          <p>辞亲朋，惜别离。登湄峰，赴瑶池。</p>
          <p>翠盖舆，幢幡仪。金童迎，玉女随。</p>
          <p>蟠桃会，天庭稀。西王母，见展眉。</p>
          <p>登金阙，拜丹墀。玉帝封，荣无比。</p>
          <p>列仙班，奉玉旨。为世民，河海理。</p>
          <p>民感念，率立祠。号神女，岁虔祈。</p>
          <p>忠孝廉，并节义。人爵荣，天爵贵。</p>
          <p>应验事，有宋始。给事中，路允迪。</p>
          <p>宣和年，使高丽。一舟存，七舟溺。</p>
          <p>祷神女，得救济。还于朝，奏宋帝。</p>
          <p>神女庙，赐顺济。封天妃，在元世。</p>
          <p>漕船忙，咸护庇。明成祖，即朱棣。</p>
          <p>遣三宝，出洋使。下西洋，连七次。</p>
          <p>国威宣，海路启。护宝船，得诏祀。</p>
          <p>灵应碑，犹存世。国姓爷，焚青衣。</p>
          <p>厦金集，聚水师。爱国心，民族气。</p>
          <p>妃助潮，登鹿耳。逐荷夷，奉永历。</p>
          <p>至清朝，康熙帝。收台湾，伐违逆。</p>
          <p>靖海侯，施琅帜。屯平海，师泉济。</p>
          <p>跨海征，舰近湄。遇暴风，舰队危。</p>
          <p>琅祈祷，妃扶持。护其安，凯旋归。</p>
          <p>琅上奏，帝解颐。诏书下，御笔批。</p>
          <p>称忠孝，称仁慈。封天后，正其时。</p>
          <p>光阴逝，叹驹驰。劝妇女，告男儿，</p>
          <p>效天后，勿延迟。回头早，到岸堤。</p>
          <p>圣母经，勤读之。口中诵，心中思。</p>
          <p>始终一，志莫移。一等人，忠烈士。</p>
          <p>曰成仁，曰取义。天日星，河岳地。</p>
          <p>人浩然，三才气。忠烈人，流芳史。</p>
          <p>背刺字，宋岳飞。文天祥，书带词。</p>
          <p>吞逆贼，巡嚼齿。留嵇血，不洗衣。</p>
          <p>头可断，将军志。骂断舌，颜烈气。</p>
          <p>吞胡羯，击楫誓。笏击贼，头破碎。</p>
          <p>出师表，苏牧羝。正气歌，示儿诗。</p>
          <p>忠鬼书，绝命词。躬尽瘁，不畏死。</p>
          <p>擎天柱，立地维。鬼神敬，纲常依。</p>
          <p>凛烈气，万古垂。为善事，我欢喜。</p>
          <p>为恶事，难保尔。或现报，或延迟。</p>
          <p>十八狱，放过谁。劝诸君，勤学之。</p>
          <p>阴骘文，指南机。感应篇，正法规。</p>
          <p>讲善事，说仁理。两宝典，必读之。</p>
          <p>万恶孽，首淫痴。速修善，改前非。</p>
          <p>福可得，祸可移。降祯祥，生孝儿。</p>
          <p>家昌盛，神助尔。圣母经，最灵威。</p>
          <p>救众生，发慈悲。逢飓风，舟船危。</p>
          <p>念此经，风自微。多疾病，身体衰。</p>
          <p>念此经，易疗医。瘟疠盛，传染时。</p>
          <p>念此经，疫自离。末劫年，多险危。</p>
          <p>念此经，转安怡。久旱魃，岁将饥。</p>
          <p>念此经，泽群黎。妇人孕，难产时。</p>
          <p>念此经，顺生儿。妖魔祟，人被迷。</p>
          <p>念此经，祟走移。洪水发，暴风起。</p>
          <p>念此经，风雨止。拜北斗，延命期。</p>
          <p>念此经，寿期颐。人无子，来求嗣。</p>
          <p>念此经，产贤智。命运凶，多是非。</p>
          <p>念此经，讼狱离。诸地狱，血污池。</p>
          <p>念此经，天堂跻。超九祖，度魅魑。</p>
          <p>功德大，难思议。灵验多，难尽辞。</p>
          <p>诵此经，万事宜。诵此经，万事宜。</p>
          <p>虔诵天上圣母经，家门清吉日康宁。</p>
          <p>虔诵天上圣母经，堂上父母享遐龄。</p>
          <p>虔诵天上圣母经，魍魉妖魅永灭形。</p>
          <p>虔诵天上圣母经，诸般营业必称情。</p>
          <p>虔诵天上圣母经，消灾解厄运通行。</p>
          <p>虔诵天上圣母经，无子祈求丹桂馨。</p>
          <p>虔诵天上圣母经，豪雨暴风即时停。</p>
          <p>虔诵天上圣母经，疾病瘟疫保不生。</p>
          <p>虔诵天上圣母经，四海波涛立刻平。</p>
          <p>虔诵天上圣母经，神清气爽道心明。</p>
          <p>虔诵天上圣母经，一年四季福禄增。</p>
          <p>虔诵天上圣母经，善功长保亨利贞。</p>
        `,
          note: `
         
<p><b>建隆岁，宋开基：</b>建隆元年，是宋朝开创基业的起点。○建隆：宋太祖赵匡胤开始使用的年号，也是宋朝的第一个年号,即公元960年。</p>
<p><b>国一统，万民期：</b>国家重归统一，百姓翘首期待。</p>
<p><b>近悦服，远来归：</b>使近处的人受惠而高兴，让远方的人闻名来投奔。○“近悦”二句：旧以“近悦远来”代指统治者给人恩惠，以便笼络人心。典出《论语·子路》：“叶公问政。子曰：‘近者说（悦），远者来’。”</p>
<p><b>天相佑，降圣妃：</b>上天也庇佑宋朝，诞降下圣妃妈祖。○圣妃：妈祖在宋代的尊称。</p>
<p><b>九牧祖，林蕴系：</b>九牧是莆田大部分林氏的祖先，林蕴一支是妈祖的直系祖宗。○九牧祖：东晋初年晋安林始祖林禄入闽，传十世至隋右丞林茂，由晋安迁居莆田北螺村。唐代传至闽林十六世林披，生九子： 林苇、林藻、林晔、林荐、林着、林蕴、林蒙、林迈、林蔇，同时擢为州牧（刺史），世称“九牧林”，尊林披为九牧林祖。○林蕴：据载九牧林第六房林蕴的后裔，散居于湄洲、忠门、吉了、莆禧等地。而天后林默为林禄的二十二世孙女，林蕴的八世孙女。妈祖属莆田九牧林家的林蕴支系。</p>
<p><b>积善久，荫门第：</b>因林家祖上积德行善,使得林门子孙得受荫佑。</p>
<p><b>林巡检，妻王氏：</b>妈祖的父亲林愿，宋初曾任都巡检，林愿妻子为王氏。</p>
<p><b>隐湄岛，诗书继：</b>妈祖曾祖父林保吉，曾在后周任武将，后弃官隐居湄洲屿，祖父林孚承袭世勋，任福建总管。父林愿，闽王时官都巡检，后亦归隐湄洲，官宦人家，诗书继世。</p>
<p><b>默娘儿，林家裔：</b>因此林默娘是九牧林家的后裔。</p>
<p><b>有一兄，并五姊：</b>妈祖有一位兄长和五位姐姐。○一兄、五姊：元代《析津志》载，妈祖兄长名洪毅；五个姐姐名大娘、十九娘、二十年娘、二十一娘、二十三娘。宋代莆田女子常以族中排行作为名字。</p>
<p><b>幺女身，行居七：</b>因此妈祖是家中老幺，排行居于第七。</p>
<p><b>默娘生，大士示：</b>林默娘的诞生，观音大士早有赐示。○大士示：传说妈祖是其母王氏吞食观音菩萨所赐药丸所生，或认为妈祖就是观音菩萨的化身。大士，佛教对菩萨的通称，又特指观音菩萨。</p>
<p><b>湄洲诞，征象奇：</b>妈祖在湄洲诞生时，出现了种种奇特的迹象。</p>
<p><b>土尽紫，香满闱：</b>妈祖出生时湄洲的土地都变成了紫色，而且有一道红光从西北射室中，晶辉夺目，异香满室。</p>
<p><b>生弥月，不闻啼：</b>妈祖出生后满月，还没听到她的哭声，因此取名为“默”，昵称默娘。</p>
<p><b>读书敏，百事知：</b>妈祖自幼聪颖，不类诸女。才八岁，从塾师训读，悉解文义。</p>
<p><b>能达礼，能作诗：</b>妈祖自小知礼仪，能作诗写字。</p>
<p><b>孝父母，守伦规：</b>尤其懂得孝顺父母亲，遵守伦理规范。</p>
<p><b>学圣道，遇明师：</b>妈祖学道时，遇到了高明的师父。○遇明师：传说妈祖十三岁时，学道术，遇到了高明的老道士玄通。</p>
<p><b>得秘诀，悟玄微：</b>玄通授予妈祖玄微秘法，妈祖受之并悉悟诸要典。</p>
<p><b>传神术，获灵机：</b>玄通所传法术，使妈祖获得灵感巧思。</p>
<p><b>窥古井，铜符持：</b>妈祖少时与群女闲游，照妆井中，得神人授予铜符一双，径可辟邪，法力日见玄通。</p>
<p><b>海上游，初显异：</b>妈祖常身在室中，而神游海上，谈吉凶祸福，靡不奇中，显示神异。</p>
<p><b>救父兄，行孝悌：</b>海上拯救父亲和长兄，是妈祖践行孝悌的故事。○妈祖有“机上救亲”故事，说的是有一年“秋九月，父与兄渡海北上。时西风正急，江上狂涛震起。妈祖方织，忽于机上闭睫游神，颜色顿变，手持梭，足踏机轴，状若有所挟而惟恐失者。母怪，急呼之，醒而梭坠，泣曰：‘阿父无恙，兄没矣。’顷而报至，果然。彼时父于怒涛中仓皇失措，几溺者屡，隐似有住其舵与其兄舟相近，无何，其兄之舵摧舟覆。盖妃当闭睫时，足踏者父之舟，手持者兄舵也。”</p>
<p><b>油成菜，生民食：</b>以菜子油种菜，供百姓食用则是妈祖的济民故事。○妈祖有“菜甲天成”故事。谓“湄有小屿在旁流中，后游其地，适母遗以菜子油，后即倾地，皆抽菜甲，灿然青黄，布满山滕，至今四时不绝，遂名为菜子屿。”</p>
<p><b>欲渡海，无舟楫。遇风涛，挂草席：</b>要渡海没有帆船，遇到风浪，用草席代替船帆，是妈祖渡海的神奇故事。○妈祖有“挂席泛槎”故事。云：“妃时欲渡江，值舟中篷桨不备。舟子以风涛汹涌，不敢解缆。妃曰：‘无事，此即草席代之。’令人悬于桅端。帆起舟驶，恍若凫鸥之浮沫。白云一苇，入水不濡，碧海孤帆，与波俱出。追狂飙而鼓棹，破巨浪而旋槎。观者惊为飞渡。”</p>
<p><b>门夹港，暗礁磊。商船触，舱进水。小草掷，大木起。船得救，众口美：</b>湄洲湾门夹（今文甲）港，暗礁磊磊。有一次商船在此遇大风触礁，船舱进水。妈祖抛掷几根小草，顷刻变成几排杉木，扶住商船不沉。商船得救，众人纷纷称异。○妈祖有“化草救商”故事。谓“屿之西有乡曰门夹，当港口出入之冲，（石多）礁错杂。有商舟渡此遭风，舟冲礁侵水，舟人哀号求救。妃曰：‘（石多）头商舟将溺，可急拯。’众见风涛震荡，不敢向前。妃乃掷草数根，化成大杉，排驾至前。舟因大木相附，得不沉。少顷，风渐平，浪渐息，舟中人相庆，皆以为天助。及阁岸整理舟楫，倏见大木瓢流，不知所向，询乡人方知化木附舟，悉神姑再造力。”</p>
<p><b>驱铁马，海上驰。不解鞍，不闻嘶：</b>妈祖能使屋檐前的铁风铃化作铁马，并驱使奔驰渡海，这铁马不必披挂或解除马鞍，也没有听见嘶鸣。○妈祖有“铁马渡江”故事。谓“时渔民往北采捕，海岸乏舟。妃渡水无楫，取檐前所悬铁马，鞭而策之，跨江如奔电追风。人见青骢行水，天马腾空，且怪且愕。及登岸，又不见解鞍嘶秣，尤为惊异。”铁马，本指屋檐下悬挂的用铜铁铸的风铃。</p>
<p><b>旱祷雨，民得济：</b>天旱时，妈祖就祈祷上天下雨，使百姓得到救济。○妈祖有“祷雨济民”故事。谓“妃年二十一岁时，莆大旱，山焦川涸，农民告困。通郡父老咸曰：‘非神姑莫解此厄。’县尹诣妃求祷。妃往祈焉。拟壬子申刻当雨。及期，日已午，烈焰丽空，片云不翳。尹曰：‘姑殆不足称神乎。’未几，阴霾四起，甘澍飘洒，平地水深三尺，西成反获有秋。众社赛日，咸欢呼顶礼，称神姑功德不可思议。”</p>
<p><b>悬菖蒲，救瘟疫：</b>妈祖教人菖蒲悬门并煎水饮服，拯救瘟疫之难。○妈祖有“灵符回生”故事。谓“岁祲，疫气盛行，莆县尹合家病笃。吏告以湄屿神姑法力广大，能起死回生，救灾恤难。尹斋戒亲诣请救。妃曰：‘此系天数。何敢妄干。’尹哀恳曰：‘千里宦游，全家客寓，生死悬于神姑，幸悯而救之。’妃念其素称仁慈，代为忏悔。取菖蒲九节，并书符咒，令贴病者门首，煎蒲饮之，病者立瘥。尹喜再生之赐，举家造门拜谢。自此神姑名彻寰宇矣。”</p>
<p><b>能驱蛟，勇除魅：</b>妈祖能驱除蛟龙，勇于剪除妖魅。○妈祖有“龙王来朝”故事。谓“东海多神怪，渔舟多溺。妃曰：‘此必怪物为殃。’乃命舟鼓枻至中流，风日晴霁，顷望见水族辏集，锦鳞彩甲，跳跃煦沫，远远涛头，拥一尊官，类王子仪容，鞠躬嵩呼于前，水潮汹涌，舟人战栗不已。妃曰：‘不须忧。’传示免迎。突然水色澄清，海不扬波，始知龙王来朝。”</p>
<p><b>伏晏公，法绳制：</b>收伏晏公，妈祖用的是法绳制伏。○妈祖有“收伏晏公”故事。谓“时有负海怪物曰晏公，每于水中趁江豚以嘘风，鼓水妖以击浪，翻溺舟楫，深为水途大患。妃游至东溟，见一碧万顷，水天涵泓，半晷间江心澎湃，舟子急呼曰：‘桅舵摇撼矣。’妃令抛椗，见一神掀髯突睛，金冠绣袖，随潮升降，触缆拂樯，形如电扫雷震。妃色不动，显出灵变。忽旋风翻浪，逆湃倒澎。彼伏神威，叩谢荡舟而还。但一时为法力所制，终未心服。继假逞色相，变一神龙，挟雾翼云，委蛇奔腾。妃曰：‘此妖不除，风波不息。’乃抛椗中流。龙左翻右滚，机破技穷，仍还本象，唯见整然衣冠，俨一尊人，驻椗不动。妃命投下（糹律）绳，彼近前附摄，不觉随摄随粘，牢固难解，飘荡浮于水上。始惧而伏罪。妃嘱之曰：‘东溟阻险，尔今统领水阙仙班，护民危厄。’由是永依法力，为部下总管。”</p>
<p><b>千里眼，顺风耳。本为精，金与水。演神咒，二精跪。收两将，作护卫：</b>千里眼和顺风耳，本是金精和水精。妈祖作法并演神咒，终于使两个精怪跪拜求皈，妈祖收伏二精，作为护卫左右的神将。○妈祖有“降伏二神”故事。谓妈祖二十三岁时，“西北方金水之精，一聪而善听，号顺风耳，一明而善视，号千里眼。二人以金水生天，出没西北为祟，村民苦之，求治于妃。妃乃杂迹于女流采摘中，十余日方与之遇。彼误认为民间女子，将近前，妃叱之，遽腾跃而去，一道火光如车轮飞越，不可方物。妃手中丝帕一拂，霾障蔽空，飞扬卷地。彼仍持铁斧疾视。妃曰：‘敢掷若斧乎？’遂掷下，不可复起。因咋舌伏法。越两载，复出为厉。幻生变态，乘涛骑沫，滚荡于浮沉荡漾之中，巫觋莫能治。妃曰：‘江河湖海，水德攸钟，彼乘旺相之乡，须木土方可克之。’至次年五、六月间，络绎问治于妃。乃演起神咒，林木震号，沙石飞扬。二神躲闪无门，遂拜伏愿皈正教。”</p>
<p><b>叩拜服，高里鬼：</b>叩拜信服妈祖的，还有高里鬼。○妈祖有“伏高里鬼”故事。谓“高里乡突有阴怪，含沙侵染百病。村人共诣神姑求治。妃知为山僻小木精作祟，取符咒贴病者考头。众如命而行，闻屋瓦响处，一物如鸟，拼飞而去。妃迹其所之，扫穴除之。比至，遽幻作一小鸟匿树抄，只见渺渺林端，炎起一团黑气。妃曰：‘不可留此为桑梓忧。’追擒之。唯一鹪鹩唧唧。将符水一洒，鸟踏空而坠，并无形体，仅存一摄枯发。举火焚之，突见本相，兀兀一小鬼子，叩拜曰：‘愿皈台下服役。’收之。”</p>
<p><b>驱二孛，通津继：</b>妈祖驱除二个孛妖，使渡桥恢复通行。○妈祖有“断桥观风”故事。谓“吉蓼城西有石桥跨海，当周道往来之津。一日，忽怪风扫地，霹雳如雷，桥柱尽折，人病涉水。相传风伯为灾。妃往观焉。遥望一道黑气，喷薄迷天，知二孛为祟，因演出灵变，俾其远遁；戒乡人晦冥风雨，毋犯之。”吉蓼，吉了，莆田忠门地名。孛（bèi），古指彗星。</p>
<p><b>破二嘉，舟安舣。收为将，功赎罪：</b>破除了嘉应、嘉佑邪术，使船舶安稳靠岸。又收伏嘉应、嘉佑为部将，让他们以功赎罪。○妈祖有“收伏嘉应、嘉佑”故事。谓“时有二魔为祟，一曰嘉应，一曰嘉佑；或于荒丘中摄魄迷魂，或于巨浪中沉舟破艇。妃至，遂逃于云天杳渺之外。适客舟至中流，风翻将沉，见赤面金装当前鼓跃。妃立化一宝货舟拍浮而游。嘉佑即舍客舟乘潮而前。妃以咒压之，击刺落荒，遂惧而伏。妃又从山路独行，嘉应不知为民间美姝，将犯之。妃拂飞尘霾，彼遂幻变腾掀，终不越故处；若有限距而无门突出者，因悚然退避。但魔心未净，岁余复作蛊害。妃曰：‘此物不归正道，毕竟为妖为孽。’令人各焚香斋戒，奉符咒，自乘小艇象渔者遨游烟波之中。嘉应见之，即冲潮登舟，坐于桅前，不觉舟驶到岸。妃伫立船头，遽悔罪请宥，并收为将，列水辟仙班，共有一十八位。凡舟人值危厄时，披发虔请求救，率得其默佑。”</p>
<p><b>锁双龙，霪雨止。岁丰盈，民大喜：</b>妈祖锁住两条蛟龙，使久雨停止。年成重获丰收，百姓欣喜不已。○妈祖有“奉旨锁龙”故事。谓“妃二十六岁春正月，霪雨至夏，淋漓弗止，闽浙尽罹其灾。省官奏闻，天子命所在祈祷。莆人诣请神姑。妃曰：‘上下多获戾于帝，故龙为灾，亦数使然。今既奉天子命，当除厥祸，为我邑造福。’见白虬奔跃冲突，又青、黄二龙洊荡于漭苍之表。妃焚灵符，忽有神龙面王冠荷戟而前曰：‘奉帝罚此一方，何可逆命。’妃曰：‘诚知玉旨降灾，但生民遭困已极，下界天子为民请命，当奏上帝赦之。’遂锁住白虬，彼一青一黄尚腾波翻覆。妃乃焚香祭告。遽有金甲神人逐潮似追寻状，天大霁，秋且告稔。有司特奏神姑锁龙神功。奉旨致币报谢。浙省水灾亦渐平。”霪雨，久下不停的雨。</p>
<p><b>弱女身，常舍己：</b>妈祖以一介女孩儿之身，却能常常舍己救人。</p>
<p><b>救世法，出乡里：</b>她的挽救时世的法术，早已传出四里八乡。</p>
<p><b>功满足，行成期：</b>但功德圆满之时，也是她升天成行之日。</p>
<p><b>纯阳体，法身飞：</b>她已修炼成阳气纯一之体，得道之身可以自由飞行。○纯阳体：信道的修行人追求一种“纯阳”之体，据说修练成纯阳之体后，就可以百病不生，长生不老。○法身：指修炼得道之身。</p>
<p><b>恩泽大，天庭知：</b>妈祖的恩惠德泽广大，天界上也已知晓。</p>
<p><b>受帝召，不敢违：</b>受到天庭玉帝的召唤，妈祖也不敢违抗。</p>
<p><b>九月九，重阳时。辞亲朋，惜别离。登湄峰，赴瑶池：</b>○九月初九重阳时节，妈祖辞别亲朋好友，不舍离别，登上湄峰之巅，升赴西天瑶池。○妈祖有“湄山飞升”故事。谓“宋太宗雍熙四年九月八日，妃语家人曰：‘心好清净，尘寰所不乐居；明辰乃重阳日，适有登高之愿，预告别期。’众咸以为登临远眺，不知其将仙也。次晨焚香演经，偕诸姊以行，谓之曰：‘今曰欲登山远游，以畅素怀，道门且长，诸姊不得同行，伤如之何。’诸人笑慰之曰：‘游则游耳，此何足多虑。’妃遂径上湄峰最高处，但见浓云横岫，白气亘天，恍闻空中丝管声韵叶宫征，直彻钧天之奏，乘风翼霭，油油然翱翔于苍旻皎日间。众咸欷骇惊叹，只见屋虹辉耀，从云端透出重霄，遨游而上，悬碧落以徘徊，俯视人世，若隐若现。忽彩云布合，不可复见。”</p>
<p><b>翠盖舆，幢幡仪：天上迎接妈祖的有华美的乘舆，盛大的旌旗仪仗。○翠盖：以翠羽为饰的车盖，泛指华美的车辆。○幢幡：旌旗之类，仪仗或军事指挥所用。</p>
<p><b>金童迎，玉女随：</b>妈祖来到天庭有童男童女迎接和随从。○金童、玉女：道家谓供仙人役使的童男童女。神仙所居洞天福地，皆有金童玉女伺侯。</p>
<p><b>蟠桃会，天庭稀：</b>参加天庭难得一见的王母蟠桃会。○蟠桃会：相传三月三日为西王母诞辰，当天西王母大开盛会，以蟠桃为主食，宴请众仙，众仙赶来为她祝寿。称为蟠桃会。传说妈祖曾赴王母瑶池之会。</p>
<p><b>西王母，见展眉：</b>意为王母见到妈祖眉开眼笑。○展眉：比喻心情愉快。</p>
<p><b>登金阙，拜丹墀：</b>登上天帝宫阙，伏拜于丹墀之下。○金阙：指天子所居的宫阙。道家谓天上也有黄金阙，为仙人或天帝所居。○丹墀：古时宫殿前的石阶，因其以红色涂饰，故名丹墀，这里指天宫的红色石阶。</p>
<p><b>玉帝封，荣无比：</b>妈祖受到了玉帝敕封，荣耀无比。○传说妈祖在凡间功果非凡，天上玉帝就赐予了“天后”天爵。</p>
<p><b>列仙班，奉玉旨：</b>从此妈祖位列天上仙人的行列，奉行玉帝的圣旨。</p>
<p><b>为世民，河海理：</b>为了人世间的民众，管理江河与湖海。</p>
<p><b>民感念，率立祠：</b>人民感激怀念妈祖功德，都纷纷建立祠庙以供祀。○率（shuài）：皆，都。</p>
<p><b>号神女，岁虔祈：</b>妈祖最初在民间被尊称为神女，年年受到虔诚祭拜祈祷。</p>
<p><b>忠孝廉，并节义：</b>妈祖成为了忠孝廉耻节义诸般品德的楷模。</p>
<p><b>人爵荣，天爵贵：</b>她因此享受人间人爵的光荣，又荣膺天上的爵位，显贵无比。</p>
<p><b>应验事，有宋始：</b>妈祖灵验的故事，从宋代开始传播。○有宋：宋代。</p>
<p><b>给事中，路允迪。宣和年，使高丽。一舟存，七舟溺。祷神女，得救济。还于朝，奏宋帝。神女庙，赐顺济：</b>北宋徽宗皇帝派遣给事中路允迪，于宣和年间出使高丽。途中遇险，只有他一艘船保存，另七条船都沉溺海里。这是因路允迪向神女妈祖祷告，得到了救助。还归宋都后，路允迪上奏皇帝，于是诏赐供奉妈祖的神女庙“顺济”匾额。○妈祖有“朱衣著灵”故事。谓宋徽宗宣和五年（1123），给事中允迪路公奉命使高丽，道东海，值大风震动，八舟溺七，独公舟危荡未覆。急祝天庇护，见一神女现桅竿，朱衣端坐。公叩头求庇。仓皇间风波骤息，藉以安。及自高丽归，语于众。保义郎李振素及墩人备述神妃显应。路公曰：‘世间惟生我者恩罔极，我等飘泊大江，身濒于死，虽父母爱育至情，莫或助之，而神姑呼吸可通，则此日实再生之赐也。’复命于朝，奏神显应。奉旨赐‘顺济’为庙额，蠲祭田税，立庙祀于江口。”</p>
<p><b>封天妃，在元世。漕船忙，咸护庇：</b>○妈祖在元代被封为天妃。其时海上漕运繁忙，都得到了妈祖的庇佑。○“封天妃”四句：元程端学《灵济庙事迹记》：“大德三年（1299），以漕运效灵，封护国庇民明著天妃。”《元史·成宗记》：“(大德三年二月)诏封泉州海神曰护国庇民明著天妃。”又妈祖有“神助漕运”故事。谓元“至顺元年（1330）春，粮船七百八十只，自太平江路太仓刘家港开洋，遇大风突起，波撼星辰，桅樯飘荡，数千人战栗哀号。官吏恳祷于神妃，言未已，倏阴云掩霭，恍见空中有朱衣拥翠盖，伫立舟前，旋有火照竿头，晶光如虹。舟人且惊且喜。无何，风平浪息，七百余艘飘流四散，正集合整理篷浆解缆而进，又闻空中有语云：‘可向东南孤岛暂泊。’众郎撑舟依孤岛旁。方抛碇，江上狂飙迅发，暴雨倒峡。舟人相慰曰：‘非神灵指示，我等皆在鼍宫蛟窟矣。’次日晴霁，遂达直沽交卸。中书奏神护相之功，奉旨赐额曰‘灵慈’。”漕船，用于漕运的船只，广义漕运指利用河道和海道调运粮食往京师或其他指定地点的运输方式；狭义的漕运指通过运河并沟通天然河道转运漕粮。</p>
<p><b>明成祖，即朱棣。遣三宝，出洋使。下西洋，连七次。国威宣，海路启。护宝船，得诏祀。灵应碑，犹存世：</b>明成祖就是永乐皇帝朱棣，他派遣三宝太监郑和等人出使西洋。郑和下西洋，前后连续七次。明廷的国威得到了宣扬，通往西洋的海路得到了开通。妈祖因庇护郑和船队，得到皇帝的御赐祭祀。《天妃灵应之记》的郑和碑，至今还保存在世上。○“明成祖”十二句：妈祖有“广州救太监郑和”故事。谓“永乐元年（1403），钦差太监郑和等往暹逻国。至广州大星洋遭风，舟将覆。舟工请祷于天妃。和祝曰：‘和奉命出使外邦，忽遭风涛危险，身固不足惜，恐无以报天子，且数百人之命悬呼吸，望神妃救之。’俄闻喧然鼓吹声，一阵香风飒飒飘来，宛见神妃立于桅端。自此风恬浪静，往返无虞。归朝复命，奏上，奉旨遣官整理祖庙。和自备宝钞五百贯，亲到湄屿致祭。”灵应碑，今福建长乐市南山郑和史迹陈列馆尚存《天妃灵应之记》碑，俗称“郑和碑”。为明宣德六年（1431），正使太监郑和、王景弘和副使李兴、朱良等人在第七次出使西洋前夕，寄泊长乐候风开洋，在重修长乐南山的天妃行宫、三峰塔寺时所立。碑文记述明永乐三年（1405）至宣德六年（1431）间，郑和奉使统率远洋船队百余艘，七次下西洋并得天妃庇佑的经历。</p>
<p><b>国姓爷，焚青衣。厦金集，聚水师。爱国心，民族气。妃助潮，登鹿耳。逐荷夷，奉永历：</b>国姓爷郑成功焚烧青衣，投笔从戎。他在厦门、金门汇集群英，组织水师，反清复明。其所秉持的是爱国之心和民族义气。在收复台湾时，得到天妃妈祖的护助，涌潮济师，从鹿耳门登岛，驱逐走荷兰殖民者，奉南明永历帝为正朔。○“国姓爷”：郑成功（1624－1662），本名森，字明俨、大木。福建南安人，父郑芝龙，母田川氏。弘光时监生，因蒙隆武帝赐明朝国姓“朱”，赐名成功，并封忠孝伯，世称“郑国姓”“国姓爷”，又蒙永历帝封延平王，称郑延平。○焚青衣：顺治三年（1646），南明隆武帝兵败被杀。24岁的郑成功焚烧青衣（儒生之服装），扬旗发兵，试图集合群英，力挽狂澜，恢复明朝天下。今南安丰州孔庙旁有“郑成功焚青衣处”石碣。○厦金集，聚水师：郑成功主要以厦门岛、金门岛为基地，聚集和操练水师。○妃助潮，登鹿耳：据载清顺治十八年（1661）三月廿三妈祖圣诞之日，郑成功起兵收复台湾。郑成功的部将林圯（同安南门铜鱼馆人，由晋江安平林氏分衍）在出征前，迎请南门的银同妈神像上战船供奉，祈求神灵庇佑。大军渡台途中二次阻风回驻彭湖。三十日风浪尚未平息，但郑成功唯恐贻误大潮汛期的有利时机，毅然下令冒风进军，并整衣冠率部将在船头设香案，冠带叩祝曰：“成功受先帝眷顾恩重，委以征伐。奈寸土未得，孤岛危居！今而移师东征，假此块地，暂借安身，俾得重整甲兵，恢复中兴。若果天命有在，而成功妄想，即时发起狂风怒涛，全军覆没；苟将来尚有一线之脉，望皇天垂怜，列祖默佑，助我潮水，俾鹢首所向，可直入无碍，庶三军从容登岸。”祝毕，令人于斗头将竹篙探水深浅。徐回报曰：“是藩主鸿福，水比往日加涨。”成功复问曰：“加涨有多少？”曰：“加涨有丈馀。”成功大喜，放炮，擂金鼓，打招旗与后面船只，好看跟踪。又密令何斌坐斗头，按图纡回，教探水者点篙，徐徐照应。转舵扬帆，呐喊，从赤崁城而进……。包围台湾城后，因久攻不下，郑成功命林圯潜入城内联络安平林氏族人，发动汉族和高山族人作内应。在外援不济、城内弹尽粮绝的情况下，侵占台湾的荷兰总督揆一于次年（1662）二月一日开城投降，被占达38年的宝岛回到了祖国的怀抱。战后评功，郑成功认为妈祖平息风浪，涌潮济师，功居首位，因此创建妈祖庙供奉银同妈神像。从此鹿耳门妈祖庙香火鼎盛，成为台湾第一座黑脸妈祖庙。○荷夷：蔑称荷兰殖民者。○永历：南明皇帝朱由榔（1623－1662）的年号。永历三年(1649),永历帝封郑成功为延平郡王,其后退守台湾郑氏政权一直使用永历年号到永历三十七年（1683）。</p>
<p><b>至清朝，康熙帝。收台湾，伐违逆。靖海侯，施琅帜。屯平海，师泉济。跨海征，舰近湄。遇暴风，舰队危。琅祈祷，妃扶持。护其安，凯旋归。琅上奏，帝解颐。诏书下，御笔批。称忠孝，称仁慈。封天后，正其时：</b>到了清代康熙皇帝，他主持统一台湾，讨伐违逆政权。封得力将领施琅为靖海侯。施琅屯兵莆田平海卫时，因淡水水源缺乏，于是拜祷妈祖，使一口枯井中涌出甘泉，水师得济，誉为“师泉”。施琅率领水师跨海征台时，当舰队到达湄洲附近时，突然遇到台风，舰队遭遇危险。施琅又虔诚地向妈祖祈祷，结果得到天妃妈祖的护助，人船得以平安，征台战争取得胜利，凯旋而归。施琅回朝后，将征台胜利及妈祖庇佑事上奏。康熙皇帝览奏后，非常高兴，便颁发诏书，御笔批复，认为妈祖对国家尽忠，对双亲尽孝，对他人仁爱、慈善。妈祖被敕封为“天后”，正是在这个时候。○违逆：违抗，指当时的台湾郑氏政权。○靖海侯：即施琅（1621-1696），字尊侯，号琢公，福建晋江人。本为郑成功部将，后降清。历任清军同安副将、同安总兵、福建水师提督。康熙二十年（1681），康熙帝采纳李光地意见，授施琅福建水师提督，积极进行攻讨统一台湾的部署。康熙二十一年（1682），康熙帝决定攻台，命施琅与福建总督姚启圣一起进取澎湖、台湾。康熙二十二年（1683）六月，施琅指挥清军水师先行在澎湖海战对台湾水师获得大胜，郑克塽率臣民降清。上疏吁请清廷在台湾屯兵镇守、设府管理，力主保留台湾、守卫台湾。施琅因功授靖海将军，封靖海侯。施琅在平定台湾过程中，与妈祖结下了不解神缘。○屯平海，师泉济：即妈祖“涌泉济师”故事。谓“靖海将军侯施于康熙二十一年十月奉命征剿，大师云屯于平海。此地斥卤，樵汲维艰。只有神宫前小井一口，甚浅，当炎天旱候，尤为枯竭；数万军取给炊爨，弗继。将军侯乃祝诸神，以大师札住，愿藉神力，俾源源可足军需。祷毕，而泉水涌溢，真不异耿恭拜井之奇。因是千万军取用不竭。爰额之曰师泉井，作师泉志以著神庥。”妈祖还有“澎湖神助得捷”故事。谓“康熙二十二年六月内，将军侯奉命征剿台湾。澎湖系台湾中道之冲，萑苻窃踞，出没要津，难以径渡。侯于是整奋大师，严饬号令。士卒舟中，咸谓恍见神妃如在左右，遂皆贾勇前进。敌大发火炮，我舟中亦发大炮，喊声震天，烟雾迷海。战舰衔尾而进，左冲右突，凛凛神威震慑，一战而杀伤彼众，并淹没者不计其数。其头目尚踞别屿，我舟放炮攻击，遂伏小舟而遁。澎湖自是肃清。先是，未克澎湖之时，署左营千总刘春梦天妃告之曰：‘二十一日必得澎湖，七月可得台湾。’果于二十二日澎湖克捷，其应如响。又是日方进战之顷，平海乡人入天妃宫，咸见天妃衣袍透湿，其左右二神将两手起泡，观者如市。及报是日澎湖得捷，方知此时即神灵阴中默助之功。将军侯因大感神力默相，奏请敕封，并议加封。奉旨：神妃已经敕封，即差礼部郎中雅虎等赍御香、御帛到湄，诣庙致祭。时将军侯到湄陪祭，见佛殿僧房尚未克竣，随即捐金二百两凑起。”</p>
<p><b>光阴逝，叹驹驰：</b>时光流逝，如白驹过隙，一去不返。○驹驰：喻指时光流逝。</p>
<p><b>劝妇女，告男儿：</b>规劝妇女，告诫男人。</p>
<p><b>效天后，勿延迟：</b>效法天后妈祖，不要拖延不决。</p>
<p><b>回头早，到岸堤：</b>早点回头，就到了苦海之岸。○回头：借喻改邪归正。</p>
<p><b>圣母经，勤读之：</b>湄洲天上圣母经，要勤读它。</p>
<p><b>口中诵，心中思：</b>口中念诵，还要心中思考。</p>
<p><b>始终一，志莫移：</b>始终如一，矢志不移。</p>
<p><b>一等人，忠烈士：</b>第一等值得尊敬的人，就是忠臣烈士。</p>
<p><b>曰成仁，曰取义：</b>说的是指成仁之人、取义之人。○成仁、取义，典出《论语·卫灵公》：“志士仁人，无求生以害仁，有杀身以成仁。”《孟子·告子上》：“生亦我所欲也，义亦我所欲也；二者不可得兼，舍生而取义者也。”仁，仁爱；义，正义。原来指两种道德境界，后来指为了正义的事业而牺牲生命。</p>
<p><b>天日星，河岳地：</b>忠臣义士，大功垂世，辉比天上日月星辰，长比地上山岳河川。</p>
<p><b>人浩然，三才气：</b>天地人并称三才，只有人才有浩然正气，故与天地并称。</p>
<p><b>忠烈人，流芳史：</b>忠臣烈士，姓名永远流芳于史册。</p>
<p><b>背刺字，宋岳飞：</b>在背上刺上“尽忠报国”四字的，是宋代的民族英雄岳飞。○背刺字：历史上有“岳母刺字”民间故事。《宋史·岳飞传》云：“初命何铸鞠之，飞裂裳，以背示铸，有‘尽忠报国’四大字，深入肤理。”但书中未注明四字出自岳母之手。</p>
<p><b>文天祥，书带词：</b>南宋文天祥临刑时，还不忘在衣带中书写取义成仁的壮烈遗书。○书带词：《宋史·文天祥传》载：“天祥临刑，殊从容……其衣带中有赞曰：‘孔曰成仁，孟曰取义，惟其义尽，所以仁至。读圣贤书，所学何事，而今而后，庶几无愧。’”清初进士钟明进作诗赞曰：“采薇不愧夷齐志，书带常悬孔孟躬。”即指此事。</p>
<p><b>吞逆贼，巡嚼齿：</b>唐代的张巡，气吞逆贼，每次战斗，斗志激昂，以至眼角崩裂流血，牙齿也都嚼碎了。○巡嚼齿：典出《旧唐书·张巡传》：“十月，城陷，(张)巡与姚誾(yín)、南霁云、许远，皆为贼所执。巡神气慷慨，每与贼战，大呼誓师，眦裂血流，齿牙皆碎。……及城陷，尹子奇谓巡曰：‘闻君每战眦裂，嚼齿皆碎，何至此耶?’巡曰：‘吾欲气吞逆贼，但力不遂耳! ’”按：张巡（709－757），蒲州河东（今山西省永济市）人，唐朝著名将领。天宝十五年（755），安史之乱中，张巡在以真源（今安徽亳州西）县令的身分，起兵守雍丘（今河南杞县），抵抗安史之乱的燕军，至德二载（757），移守睢阳（今河南商丘），与太守许远共同作战，在内无粮草，外无援兵的情况下，城破被俘，英勇就义。他以区区两县几千兵力，苦守雍丘、睢阳二个孤城近二年，显示了杰出的军事才能。唐代追赠张巡为扬州大都督。死后追封通真三太子，莆田人则尊奉为司马圣王。</p>
<p><b>留嵇血，不洗衣：</b>保存嵇侍中血迹，不忍洗衣是纪念忠臣嵇绍的故事。○留嵇血：《忠经·嵇绍卫帝》载：“晋嵇绍，字延祖，（嵇）康之子也。事母孝，累官至侍中。会河间成都二王举兵，绍从（晋）惠帝与王战于汤阴。大败，百官皆奔，侍卫尽散，惟绍独以身捍卫，飞箭雨集，死之，血溅御衣。事定，左右欲浣衣，帝曰：‘此嵇侍中血，勿浣。’”</p>
<p><b>头可断，将军志：</b>头可以断，人不会投降，是东汉末严颜的壮志。○头可断：《三国志·蜀志·张飞传》载，东汉末严颜为刘璋麾下部将，镇守巴郡。建安十九年，张飞攻打巴郡，俘虏了严颜，要他投降。严颜回答说：“我州但有断头将军，无降将军也!”张飞发怒，令左右砍其头，然而严颜面色不变。张飞敬佩其正气浩然，威武不屈，就释放了他。文天祥《正气歌》中“为严将军头”句即夸赞此人。</p>
<p><b>骂断舌，颜烈气：</b>痛骂叛贼，以致断舌，显示的是颜杲卿的英雄气概。○骂断舌：唐代颜杲卿（692－756），字昕，长安万年人，和颜真卿同为颜师古五代孙。父颜元孙，任濠州刺史。颜初任范阳户曹参军，曾是安禄山的部下。天宝十四载，安史之乱时，杲卿和儿子季明守常山，任太守，颜真卿守平原，设计杀安禄山部将李钦凑，擒高邈、何千年。河北有十七郡响应。天宝十五载，安禄山叛军围攻常山，叛军抓到颜季明，借此逼迫颜杲卿投降，但颜杲卿不肯屈服，还大骂安禄山，季明被杀。不久城为史思明所破，颜杲卿被押到洛阳，见到安禄山，安责问颜杲卿背叛他，颜杲卿说“我世为唐臣，常守忠义，怎么会跟一个牧羊羯奴叛乱。”安大怒，命令割掉颜杲卿的舌头，颜杲卿仍大骂不止，直至气绝。文天祥《正气歌》中“为颜常山舌”即赞此人。</p>
<p><b>吞胡羯，击楫誓：</b>气吞胡人，拍击船桨立誓收复中原的是晋代的祖逖。○吞胡羯：祖逖（266－321），字士稚，范阳遒县（今河北涞水）人。东晋初期著名的北伐将领。曾率兵伐苻秦，渡江于中流，祖逖手敲船桨（中流击揖），向众人发誓说：“祖逖此去，若不能平定中原，驱逐敌寇，则如这涛涛江水，一去不返！”后常用为颂扬收复失地统一国家的壮志之典。胡羯，古代汉族对北方少数民族的称呼。史书上曾称匈奴、鲜卑、羯、氐、羌为五胡。</p>
<p><b>笏击贼，头破碎：</b>以笏板击破叛贼之头，是段秀实的英勇故事。○笏击贼：《新唐书·段秀实传》载，唐德宗时，叛将朱泚谋反，自立为大秦皇帝，召名将段秀实议事，段秀实不肯同流合污，以笏板猛击朱泚的头，大骂：“狂贼，吾恨不斩汝万段，岂从汝反耶？”旋被杀。文天祥《正气歌》中“或为击贼笏，逆竖头破裂”即咏此事。笏，古代大臣朝见皇帝时所持的手板。</p>
<p><b>出师表，苏牧羝：</b>蜀汉诸葛亮以撰《出师表》表忠心，西汉苏武在匈奴十九年牧羊不改爱国气节。○出师表：三国时蜀汉丞相诸葛亮（孔明）在北伐中原之前给后主刘禅上书的表文，阐述了北伐的必要性以及对后主刘禅治国寄予的期望，言辞恳切，表达出一片赤诚之心。历史上有《出师表》有《前出师表》和《后出师表》，一般所说的《出师表》指《前出师表》。○苏牧羝：“苏”指苏武(前140—前60)，字子卿，杜陵（今陕西西安东南）人。早年以父荫为郎，天汉元年(前100)拜中郎将，并奉命以中郎将持节出使匈奴。适匈奴上层发生内乱，苏武被扣留。单于多次胁迫他投降，苏武不屈服。后来单于把他流放到“北海（今贝加尔湖）上无人处，使牧羝，羝乳乃得归”。羝是公羊，根本不会生仔产奶，以此来断绝他回汉的希望。苏武历尽艰辛，留居匈奴十九年持节不屈。至始元六年（前81），方获释回汉。苏武死后，汉宣帝将其列为麒麟阁十一功臣之一，表彰其爱国节操。</p>
<p><b>正气歌，示儿诗：</b>文天祥的《正气歌》，陆游的《示儿诗》都表现出坚贞的爱国情操。○正气歌：南宋末代右丞相文天祥所作的诗，创作于元大都监狱中。全诗慷慨激昂，充分表现了文天祥的坚贞不屈的爱国情操。○示儿诗：南宋陆游所作。陆游（1125-1210），字务观，号放翁，是我国南宋杰出的爱国诗人。他在临终前作《示儿》诗：“死去元知万事空，但悲不见九州岛同。王师北定中原日，家祭无忘告乃翁。”是一首感人至深、传诵千古的名作。</p>
<p><b>忠鬼书，绝命词：</b>明代左懋第有“死为大明忠鬼”书，历代绝命词更是生命的绝唱。○忠鬼书：明代山东莱阳人左懋第（1601-1645），字仲及，号萝石。宁死不肯降清，被誉为“明末文天祥”。据明人谈迁《北游录·纪闻上·左懋第》载：“左萝石北使被幽，弘光败报至，摄政王使人宴左侍郎，饮颇酣。问今日何故，曰‘此太平宴。’问所自，曰‘江南破矣。’左大怒，仆席于地。其绝命诗曰：‘山折巢封归路迥，片云南向意何如?寸丹冷魄消难尽，荡作寒江总不磨。’闰六月十八日临刑，又书曰：‘生为大明忠臣，死为大明忠鬼。’都人吴某收殡。”○绝命词：历代留下绝命词慷慨殉国者，不止一人。如明末的夏允彝，《明史》载“允彝字彝中，华亭（今属上海松江）人。赐冠举於乡。好古博学，工属文，暇时偶作印章。是时东林方讲学苏州，张溥、杨廷枢等慕之，结文会，名曰复社。允彝与周邑陈子龙等结几社相和。清兵陷南京，欲结义民抗之，闻友人侯峒曾、董淳耀、徐湃等皆死，乃赋《绝命词》，投水死。”又如明桂王被拘捕，明沅江总兵皮熊得知，躲避到水西，绝食七天仍不死。吴三桂派人捕来，他背对清兵而立，不听命令，绝食到十三天，开始变哑说不出话来，又隔一日才断气，其尸被戮。皮熊女婿赵黔被捕，命令他交待言行，赵黔写《绝命词》送上，被杀。</p>
<p><b>躬尽瘁，不畏死：</b>鞠躬尽瘁，不怕牺牲。○躬尽瘁：竭尽劳苦，贡献出全部力量。躬，身躯,亦借指自己。</p>
<p><b>擎天柱，立地维：</b>忠臣烈士，是撑天之柱子，是系地之纲绳。○天柱：支撑天的柱子。○地维：系挂地的绳子。《淮南子》：“昔者，共工与颛顼争为帝，怒而触不周之山，天柱折，地维绝。”天柱折，地维绝的意思支撑天的柱子折了，系挂地的绳子断。</p>
<p><b>鬼神敬，纲常依：</b>伦常纲维，遵守依行，则鬼神钦敬。○纲常：纲，提网的总绳，喻指事物的关键部分；常，经久不变。“纲常”本特指封建时代的三纲五常（君为臣纲、父为子纲、夫为妻纲以及仁、义、礼、智、信）。</p>
<p><b>凛烈气，万古垂：</b>凛然的正气，将永世流传。</p>
<p><b>为善事，我欢喜：</b>你做了好事，我高兴。</p>
<p><b>为恶事，难保尔：</b>你做了坏事，我难以保佑。</p>
<p><b>或现报，或延迟：</b>报应之法，有的马上呈现，有的延迟后报。○“或现报”二句：据说祖宗父母无余德可抵作恶者，则立见报应；祖宗父母有余德可抵作恶者，则延迟报应，但德尽必报。</p>
<p><b>十八狱，放过谁：</b>十八层地狱,是不会放过哪个作恶者的。○十八狱：亦作“十八地狱”，即十八层地狱（或称十八地狱、十八重地狱、十八泥犁），本出佛教轮回之说，佛教传入中国后，为道教所沿用和解释。地狱被认为是许多人死亡后灵魂所去的地方，在汉族传统宗教观念中，地狱是阴间地府的一部分。十八层地狱之说，意在劝人们在活着的时候多做善事，多积德。如果生前作恶，死后就会在十八层地狱中受苦，无比凄惨。</p>
<p><b>劝诸君，勤学之：</b>劝告各位，要勤学向善。</p>
<p><b>阴骘文，指南机：</b>《阴骘文》便是积德善行的指针。○阴骘（zhì）文：全称《文昌帝君阴骘文》，道书一种，以文昌帝君降笔（扶乩）的名义编纂而成。文昌帝君全称辅元开化文昌司禄宏仁帝君，或称梓潼帝君、梓潼神，相传为掌握人间禄籍之神，旧时士人多崇祀之。阴骘，原为“默默地安定”之意，《尚书·洪范》：“惟天阴骘下民，相协厥居。”引申为修善积德，俗称积阴德。《阴骘文》以天人感应和因果报应思想为依据，宣传儒家道德规范和道、释宗教戒条，说明广行阴骘，将得善报。文中列举忠主、孝亲、敬兄、信友、矜孤恤寡、敬老怜贫、不谋人财产、不淫人妻女、不恃富豪而欺穷困，不倚权势而辱善良等数十项作为立身处世之准则。○指南机：指南针。</p>
<p><b>感应篇，正法规：</b>《感应篇》则是正道的规条。○感应篇：即《太上感应篇》，简称《感应篇》，中国道教善书，托名太上老君所授，其书融合了较多的佛教和儒家思想。如认为“大地有司过之神，依人所犯轻重以夺人算”，“又有三台北斗神君在人头上，录人罪恶，夺其纪算”，“又有三尸神在人身中每到庚申日，辄上诣天曹言人罪过”等，认为人们的所作所为是通过天地鬼神来裁决的。○正法规：正道之规条、法则。</p>
<p><b>讲善事，说仁理：</b>讲解慈善的事情，说明仁德的理义。</p>
<p><b>两宝典，必读之：</b>上面两部宝典，一定要认真阅读。○两宝典：即《文昌帝君阴骘文》和《太上感应篇》二种劝善书。</p>
<p><b>万恶孽，首淫痴：</b>万般罪恶，首条就是淫邪和痴迷不悟。</p>
<p><b>速修善，改前非：</b>作恶者应马上断恶行善，痛改前非。</p>
<p><b>福可得，祸可移：</b>这样就可以获得幸福，移除灾祸。</p>
<p><b>降祯祥，生孝儿：</b>天降吉祥，诞生孝顺儿孙。</p>
<p><b>家昌盛，神助尔：</b>家庭兴旺发达，神灵会佑助你。</p>
<p><b>圣母经，最灵威：</b>天上圣母经，最为灵验权威。</p>
<p><b>救众生，发慈悲：</b>妈祖为拯救众生，大发慈悲之心。</p>
<p><b>逢飓风，舟船危。念此经，风自微：</b>当遭遇台风，船只临危时，念诵本经，风势自会变小。○飓风：古称发生在海洋上的强烈暴风。</p>
<p><b>多疾病，身体衰。念此经，易疗医：</b>当发生较多疾病，身体衰弱时，念诵本经，就会容易治好疾病。○疗医：治疗。</p>
<p><b>瘟疠盛，传染时。念此经，疫自离：</b>当瘟疫和恶疾流行，甚至传染时，念诵本经，瘟疫就会离你而去。○疠：恶疾。</p>
<p><b>末劫年，多险危。念此经，转安怡：</b>当世道混乱，社会危险较多时，念诵本经，就会使自己转危为安。○末劫年：末法之劫，乱世之年。末法，本为佛家语，指佛法的衰落期。○险危：危险。○安怡：安适愉快。</p>
<p><b>久旱魃，岁将饥。念此经，泽群黎：</b>当久旱不雨，年成将要饥荒时，诵念此经，可以惠泽百姓。○旱魃：中国古代汉族神话传说中引起旱灾的怪物，借指旱灾。○群黎：百姓。</p>
<p><b>妇人孕，难产时。念此经，顺生儿：</b>当妇女怀孕,难产时,诵念此经，可以顺利生下婴儿。</p>
<p><b>妖魔祟，人被迷。念此经，祟走移：</b>当妖魔作祟,人被迷惑时,诵念此经，可以移除害人的邪祟。○走移：移走。</p>
<p><b>洪水发，暴风起。念此经，风雨止：</b>当洪水爆发，暴风发生时，诵念此经，可以让风雨快速停止。</p>
<p><b>拜北斗，延命期。念此经，寿期颐：</b>当祭拜北斗，希望延长寿命时，念诵本经，可以长命百岁。○北斗：道经中认为南斗星注生，北斗星主死。唐《老子中经》：“北斗君者，天之侯王，主制万二千神，持人命籍”；《北斗真经》：“实心望北极，稽首礼拜……皆得延生注福，系系人身，灾厄蠲除，获福无量。”古代“拜北斗延年寿”的故事甚多，如“汉相国霍光家奴名还东者，拜北斗，增年六百岁”(《云笈七签》)；“颜超貌主夭亡”，颜父以酒脯享“北斗星君”，“增年至九十岁”(《搜神记》)。○期颐：百岁。</p>
<p><b>人无子，来求嗣。念此经，产贤智：</b>当夫妻没有儿子，来求子嗣时，诵念此经，可以产下贤能的后代。○求嗣：求生子，嗣，后嗣。○贤智：指贤德才智的后代。</p>
<p><b>命运凶，多是非。念此经，讼狱离：</b>当命运不佳，多惹是非之时，诵念此经，可以远离麻烦的官司。○讼狱：诉讼、官司。</p>
<p><b>诸地狱，血污池。念此经，天堂跻：</b>已被囚禁于地狱血盆池受苦的带罪之魂，念诵此经，可使其超离地狱，升登天堂。○血污池：又称血池地狱。迷信传说是阴间的一百三十八地狱之一。据说凡生前喜好宰杀禽畜污染神器者，虐待奴婢殴打出血者，男女交欢犯禁者，产妇难产而死或产后犯忌者等，都会被打入血池地狱。○跻：登，上升。</p>
<p><b>超九祖，度魅魑：</b>念诵经书，可超拔历代之祖宗，可超度阴间之恶鬼。○九祖：九世之祖先，泛称历代祖宗。○魅魑：泛指各种魔怪。</p>
<p><b>功德大，难思议：</b>功德法力巨大，有不可思议的灵验。</p>
<p><b>灵验多，难尽辞：</b>妈祖的灵验甚多，难以用言辞表达。</p>
<p><b>诵此经，万事宜：</b>念诵此经，万事适宜。</p>
<p><b>虔诵天上圣母经，家门清吉日康宁：</b>虔诚念诵天上圣母经，一家吉祥日日安。○清吉：清平吉祥。</p>
<p><b>虔诵天上圣母经，堂上父母享遐龄：</b>虔诚念诵天上圣母经，家中父母寿命长。○遐龄：高龄，长寿。</p>
<p><b>虔诵天上圣母经，魍魉妖魅永灭形：</b>虔诚念诵天上圣母经，妖魔鬼怪无踪影。○魍魉妖魅：泛指妖魔鬼怪。</p>
<p><b>虔诵天上圣母经，诸般营业必称情：</b>虔诚念诵天上圣母经，种种营生都如意。○诸般：种种。○称情：称心如意。</p>
<p><b>虔诵天上圣母经，消灾解厄运通行：</b>虔诚念诵天上圣母经，消除灾祸运气通。○消灾解厄：消除灾祸，解救危难。</p>
<p><b>虔诵天上圣母经，无子祈求丹桂馨：</b>虔诚念诵天上圣母经，求子必生佳子弟。○丹桂：桂树的一种，旧时称科举中第为折桂，因以丹桂比喻科第。亦喻指子息，尊称人子曰桂子。</p>
<p><b>虔诵天上圣母经，豪雨暴风即时停：</b>虔诚念诵天上圣母经，暴雨狂风即可停。○豪雨暴风：暴雨狂风。</p>
<p><b>虔诵天上圣母经，疾病瘟疫保不生：</b>虔诚念诵天上圣母经，大小疾病都不生。</p>
<p><b>虔诵天上圣母经，四海波涛立刻平：</b>虔诚念诵天上圣母经，海上波涛立即平。</p>
<p><b>虔诵天上圣母经，神清气爽道心明：</b>虔诚念诵天上圣母经，神志清爽仁心显。○道心：追求世间法则至理之心。“道”代表世间法则。</p>
<p><b>虔诵天上圣母经，一年四季福禄增：</b>虔诚念诵天上圣母经，一年四季福祉添。○福禄：幸福与爵禄。</p>
<p><b>虔诵天上圣母经，善功长保亨利贞：</b>虔诚念诵天上圣母经，善行功德保亨通。○善功：善行之功。○亨利贞：意指亨通大吉。《易经》：“乾，元亨利贞。”意为乾卦主亨通祥和贞正，所测之事主大吉。又：“兑，亨利贞。”意为兑卦属泽，泽润万物，所以亨通，且对正者有利。</p>
`,
        },
        {
          title: "完经赞",
          text: `
          <p>经功完满，威德无疆。</p>
          <p>瑞云紫气霭盈堂，赐福降祯祥。</p>
          <p>永佑安康，赞诵普隆昌。</p>
          <p>玉封天后天上圣母元君。——三称</p>
        `,
          note: `
       
         <p><b>⑴ 完经赞：</b>念诵完经文的赞歌。</p>
         <p><b>⑵ 经功完满，威德无疆：</b>诵经之功已圆满完成，妈祖给予的威力恩德将无穷无尽。</p>
         <p><b>⑶ 瑞云紫气霭盈堂，赐福降祯祥：</b>祥瑞的云彩、紫色的霞气，蒸腾并充满厅堂，这是上天赐福降祥的征兆。○祯祥：吉祥的征兆。</p>
         <p><b>⑷ 永佑安康，赞诵普隆昌：</b>天后永远保佑大家的安康，高声赞颂普天下隆盛并安昌。</p>
       `,
        },
        {
          title: "回向偈",
          text: `
          <p>天妃度化应人间，海上现身救苦难。</p>
          <p>菩萨心肠悲浊世，威神到处挽狂澜。</p>
        `,
          note: `
         
          <p><b>⑴ 回向偈：</b>回向的诗偈。○回向偈：原是佛教用语。修行之人诵经念佛完毕，均将回向偈或回向文念一遍。回，回转也；向，趣向也。“回向”有归拢和趋向的意思，就是要把诵经的功德汇集到一个目的上去。○偈（jì）：梵语“偈陀”的简称，佛经中的唱颂词，也意译为“颂”。形式和古诗类似，通常以四句为一首。</p>
          <p><b>⑵ 天妃度化应人间：</b>天妃妈祖超度点化凡间的世人。○度化：超度、点化。</p>
          <p><b>⑶ 海上现身救苦难：</b>她经常在海上显灵以救苦救难。</p>
          <p><b>⑷ 菩萨心肠悲浊世：</b>怀着菩萨的心肠思虑人间尘世。○浊世：尘世，凡间。</p>
          <p><b>⑸ 威神到处挽狂澜：</b>以赫奕的声威处处去力挽狂澜。○狂澜：巨大的波浪。</p>
          `,
        },
      ],
      dialogShow: false,
      nowNote: {},
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    notes(item) {
      this.nowNote = item;
      this.dialogShow = true;
      this.$nextTick(() => {
        this.$refs.nodeRef.scrollTop = 0;
      });
    },
    clsoeNote() {
      this.dialogShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

@media screen and (min-width: 1001px) {
  .block {
    width: 100%;
    overflow: hidden;
    padding-top: $head-height;
    height: 100%;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);

    .title {
      padding: 1rem 2rem;
      text-align: right;
      color: $c-text-main;
    }

    .data_box {
      display: flex;
      justify-content: center;
      align-items: center;
      .shell {
        width: 90%;
        height: 38rem;
        display: flex;
        height: calc(100vh - $head-height - 4rem);
        box-sizing: border-box;
        .box {
          flex: 1;
          overflow: hidden;
          transition: 0.5s;
          margin: 0 0.4rem;
          box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.5);
          border-radius: $r-mid;
          background: url("../../../assets/img/wl_7.png");
          background-color: #fff;
          &:hover {
            flex-basis: 20%;
            .number,
            .title {
              display: none;
            }
            .in_title,
            .text {
              display: block;
            }
          }

          .number {
            border: 1px solid $ccc-gold;
            color: rgb(231, 25, 25);
            width: 2rem;
            height: 2rem;
            margin: 1rem auto;
            text-align: center;
            font-size: $f-hug;
            line-height: 2rem;
            border-radius: 50%;
            padding: 0.4rem;
          }
          .title {
            font-size: $f-hug;
            margin: 0 auto;
            margin-top: 2rem;
            padding-top: 2rem;

            border: 1px solid $ccc-gold;
            box-sizing: border-box;
            color: $ccc-gold;
            width: 90%;
            height: 254px;
            line-height: 54px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            writing-mode: vertical-rl;
          }
          .in_title {
            display: none;
            text-align: center;
            width: 100%;
            font-size: $f-big;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid $ccc-gold;
            color: $ccc-gold;
            font-weight: 700;

            .notes {
              font-size: $f-lit;
              float: right;
              margin-right: 0.6rem;
              margin-top: 0.4rem;
              color: $c-text-main;
              cursor: pointer;
              transition: 0.3s;
              &:hover {
                color: $ccc-gold;
                transform: scale(1.1);
                i {
                  color: $c-main;
                }
              }
              i {
                color: $ccc-gold;
              }
            }
          }
          .text {
            display: none;
            font-size: $f-mid;
            width: 90%;
            margin: 0 auto;
            max-height: 34rem;
            overflow: hidden;
            overflow-y: auto;
            ::v-deep p {
              border-bottom: 1px solid $ccc-gold;
            }
          }
        }
      }
    }
  }
  .nodeBox {
    border: 1px solid $ccc-gold;
    height: calc(100vh - $head-height - 6rem);
    padding: 0.6rem;
    box-sizing: border-box;
    justify-content: space-around;
    background: url("../../../assets/img/wl_7.png");
    display: flex;
    .textBox,
    .node {
      width: 48%;
      margin: 0 auto;
      padding: 0.2rem 0.6rem;
      background: radial-gradient(
            circle at bottom left,
            transparent 15px,
            #fffdf9 16px
          )
          bottom left,
        radial-gradient(circle at top left, transparent 15px, #fffdf9 16px) top
          left,
        radial-gradient(circle at top right, transparent 15px, #fffdf9 16px) top
          right,
        radial-gradient(circle at bottom right, transparent 15px, #fffdf9 16px)
          bottom right;
      background-size: 51% 51%;
      background-repeat: no-repeat;
    }
    .text {
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
      margin-top: 2rem;
      height: calc(100vh - $head-height - 12rem);
    }
    .node {
      .nodeTitle {
        font-size: $f-mid;
        color: $ccc-gold;
        border-bottom: 1px solid $ccc-gold;
        text-align: left;
        padding: 0.4rem 0.6rem;
      }
      .nodeText {
        overflow: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        height: calc(100vh - $head-height - 12rem);

        ::v-deep b {
          color: $ccc-gold;
        }
      }
    }
  }
}
@media screen and (min-width: 651px) and (max-width: 1000px) {
  .block {
    width: 100%;
    overflow: hidden;
    padding-top: $head-height;
    height: 100%;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);

    .title {
      padding: 1rem 2rem;
      text-align: right;
      color: $c-text-main;
    }

    .data_box {
      display: flex;
      justify-content: center;
      align-items: center;
      .shell {
        width: 90%;
        height: 38rem;
        display: flex;
        height: calc(100vh - $head-height - 4rem);
        box-sizing: border-box;
        .box {
          flex: 1;
          overflow: hidden;
          transition: 0.5s;
          margin: 0 0.1rem;
          box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.5);
          border-radius: $r-mid;
          // padding: 0.2rem;
          background: url("../../../assets/img/wl_7.png");
          background-color: #fff;
          &:hover {
            flex-basis: 40%;
            .number,
            .title {
              display: none;
            }
            .in_title,
            .text {
              display: block;
            }
          }

          .number {
            border: 1px solid $ccc-gold;
            color: rgb(231, 25, 25);
            width: 1.5rem;
            height: 1.5rem;
            margin: 1rem auto;
            text-align: center;
            font-size: $f-mid;
            line-height: 1.5rem;
            border-radius: 50%;
            padding: 0.4rem;
          }
          .title {
            font-size: $f-mid;
            margin-top: 1rem;
            padding-top: 2rem;
            border-top: 1px solid $ccc-gold;
            box-sizing: border-box;
            color: $ccc-gold;
            width: 100%;
            height: 15rem;
            // line-height: 24px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            writing-mode: vertical-rl;
          }
          .in_title {
            display: none;
            text-align: center;
            width: 100%;
            font-size: $f-big;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid $ccc-gold;
            color: $ccc-gold;
            font-weight: 700;

            .notes {
              font-size: $f-lit;
              float: right;
              margin-right: 0.6rem;
              margin-top: 0.4rem;
              color: $c-text-main;
              cursor: pointer;
              transition: 0.3s;
              &:hover {
                color: $ccc-gold;
                transform: scale(1.1);
                i {
                  color: $c-main;
                }
              }
              i {
                color: $ccc-gold;
              }
            }
          }
          .text {
            display: none;
            font-size: $f-mid;
            width: 90%;
            margin: 0 auto;
            max-height: 34rem;
            overflow: hidden;
            overflow-y: auto;
            ::v-deep p {
              border-bottom: 1px solid $ccc-gold;
            }
          }
        }
      }
    }
  }
  .nodeBox {
    border: 1px solid $ccc-gold;
    height: calc(100vh - $head-height - 6rem);
    padding: 0.6rem;
    box-sizing: border-box;
    justify-content: space-around;
    background: url("../../../assets/img/wl_7.png");
    display: flex;
    .textBox,
    .node {
      width: 48%;
      margin: 0 auto;
      padding: 0.2rem 0.6rem;
      background: radial-gradient(
            circle at bottom left,
            transparent 15px,
            #fffdf9 16px
          )
          bottom left,
        radial-gradient(circle at top left, transparent 15px, #fffdf9 16px) top
          left,
        radial-gradient(circle at top right, transparent 15px, #fffdf9 16px) top
          right,
        radial-gradient(circle at bottom right, transparent 15px, #fffdf9 16px)
          bottom right;
      background-size: 51% 51%;
      background-repeat: no-repeat;
    }
    .text {
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
      margin-top: 2rem;
      height: calc(100vh - $head-height - 12rem);
    }
    .node {
      .nodeTitle {
        font-size: $f-mid;
        color: $ccc-gold;
        border-bottom: 1px solid $ccc-gold;
        text-align: left;
        padding: 0.4rem 0.6rem;
      }
      .nodeText {
        overflow: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        height: calc(100vh - $head-height - 12rem);

        ::v-deep b {
          color: $ccc-gold;
        }
      }
    }
  }
}
@media screen and (min-width: 451px) and (max-width: 650px) {
  .block {
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    padding-top: $head-height;
    height: 100%;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);

    .title {
      padding: 1rem 2rem;
      text-align: right;
      color: $c-text-main;
    }

    .data_box {
      display: flex;
      justify-content: center;
      align-items: center;
      .shell {
        width: 90%;
        // display: flex;
        // flex-direction: column;
        height: calc(100vh - $head-height - 4rem);
        padding: 0.2rem;
        box-sizing: border-box;
        // overflow: hidden;
        // overflow-y: auto;
        .box {
          // flex: 1;
          height: 4rem;
          overflow: hidden;
          transition: 0.5s;
          margin: 0.2rem 0;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
          border-radius: $r-mid;
          background: url("../../../assets/img/wl_7.png");
          background-color: #fff;
          &:hover {
            // flex-basis: 40%;
            height: 34rem;
            .number,
            .title {
              display: none;
            }
            .in_title,
            .text {
              display: block;
            }
          }

          .number {
            border: 1px solid $ccc-gold;
            color: rgb(231, 25, 25);
            width: 1.5rem;
            height: 1.5rem;
            margin-left: 2rem;
            text-align: center;
            font-size: $f-mid;
            border-radius: 50%;
            padding: 0.4rem;
            display: inline-block;
          }
          .title {
            font-size: $f-mid;
            box-sizing: border-box;
            color: $ccc-gold;
            display: inline-block;
          }
          .in_title {
            display: none;
            text-align: center;
            width: 100%;
            font-size: $f-big;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid $ccc-gold;
            color: $ccc-gold;
            font-weight: 700;

            .notes {
              font-size: $f-lit;
              float: right;
              margin-right: 1.6rem;
              margin-top: 0.4rem;
              color: $c-text-main;
              cursor: pointer;
              transition: 0.3s;
              &:hover {
                color: $ccc-gold;
                transform: scale(1.1);
                i {
                  color: $c-main;
                }
              }
              i {
                color: $ccc-gold;
              }
            }
          }
          .text {
            display: none;
            font-size: $f-mid;
            width: 90%;
            margin: 0 auto;
            max-height: 30rem;
            overflow: hidden;
            overflow-y: auto;

            ::v-deep p {
              padding-left: 1rem;
              border-bottom: 1px solid $ccc-gold;
            }
          }
        }
      }
    }
  }
  .nodeBox {
    border: 1px solid $ccc-gold;
    height: calc(100vh - $head-height - 6rem);
    padding: 0.6rem 0;
    box-sizing: border-box;
    justify-content: space-around;
    background: url("../../../assets/img/wl_7.png");
    display: flex;
    .textBox,
    .node {
      margin: 0 auto;
      padding: 0.2rem 0.4rem;
      background: radial-gradient(
            circle at bottom left,
            transparent 15px,
            #fffbf2 16px
          )
          bottom left,
        radial-gradient(circle at top left, transparent 15px, #fffbf2 16px) top
          left,
        radial-gradient(circle at top right, transparent 15px, #fffbf2 16px) top
          right,
        radial-gradient(circle at bottom right, transparent 15px, #fffbf2 16px)
          bottom right;
      background-size: 51% 51%;
      background-repeat: no-repeat;
    }
    .textBox {
      width: 43%;
    }
    .text {
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
      margin-top: 2rem;
      height: calc(100vh - $head-height - 12rem);
    }
    .node {
      width: 53%;
      border-left: 1px dashed $ccc-gold;
      .nodeTitle {
        font-size: $f-mid;
        color: $ccc-gold;
        border-bottom: 1px solid $ccc-gold;
        text-align: left;
        padding: 0.4rem 0.6rem;
      }
      .nodeText {
        overflow: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        height: calc(100vh - $head-height - 12rem);

        ::v-deep b {
          color: $ccc-gold;
        }
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .block {
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    padding-top: $head-height;
    height: 100%;
    box-sizing: border-box;
    background-color: rgb(255, 255, 255);

    .title {
      padding: 1rem 2rem;
      text-align: right;
      color: $c-text-main;
    }

    .data_box {
      display: flex;
      justify-content: center;
      align-items: center;
      .shell {
        width: 90%;
        // display: flex;
        // flex-direction: column;
        height: calc(100vh - $head-height - 4rem);
        padding: 0.2rem;
        box-sizing: border-box;
        // overflow: hidden;
        // overflow-y: auto;
        .box {
          // flex: 1;
          height: 3rem;
          line-height: 1rem;
          overflow: hidden;
          transition: 0.5s;
          margin: 0.2rem 0;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
          border-radius: $r-mid;
          background: url("../../../assets/img/wl_7.png");
          background-color: #fff;
          &:hover {
            // flex-basis: 40%;
            height: 30rem;
            .number,
            .title {
              display: none;
            }
            .in_title,
            .text {
              display: block;
            }
          }

          .number {
            border: 1px solid $ccc-gold;
            color: rgb(231, 25, 25);
            width: 1.5rem;
            height: 1.5rem;
            line-height: 1.5rem;
            margin-left: 2rem;
            text-align: center;
            font-size: $f-mid;
            border-radius: 50%;
            padding: 0.3rem;

            display: inline-block;
          }
          .title {
            font-size: $f-mid;
            box-sizing: border-box;
            color: $ccc-gold;
            display: inline-block;
          }
          .in_title {
            display: none;
            text-align: center;
            width: 100%;
            font-size: $f-mid;
            margin-top: 1rem;
            margin-bottom: 0.5rem;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid $ccc-gold;
            color: $ccc-gold;
            font-weight: 700;

            .notes {
              font-size: $f-lit;
              float: right;
              margin-right: 1.6rem;
              margin-top: 0.4rem;
              color: $c-text-main;
              cursor: pointer;
              transition: 0.3s;
              &:hover {
                color: $ccc-gold;
                transform: scale(1.1);
                i {
                  color: $c-main;
                }
              }
              i {
                color: $ccc-gold;
              }
            }
          }
          .text {
            display: none;
            font-size: $f-lit;
            width: 90%;
            margin: 0 auto;
            max-height: 30rem;
            overflow: hidden;
            overflow-y: auto;

            ::v-deep p {
              padding-left: 1rem;
              border-bottom: 1px solid $ccc-gold;
            }
          }
        }
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 0.2rem;
  }
  .nodeBox {
    font-size: $f-lit;
    border: 1px solid $ccc-gold;
    height: calc(100vh - $head-height - 3rem);
    // padding: 0.6rem 0;
    box-sizing: border-box;
    justify-content: space-around;
    background: url("../../../assets/img/wl_7.png");
    // display: flex;
    overflow: hidden;

    .textBox,
    .node {
      margin: 0 auto;
      padding: 0.2rem 0.4rem;
      background: radial-gradient(
            circle at bottom left,
            transparent 15px,
            #fffbf2 16px
          )
          bottom left,
        radial-gradient(circle at top left, transparent 15px, #fffbf2 16px) top
          left,
        radial-gradient(circle at top right, transparent 15px, #fffbf2 16px) top
          right,
        radial-gradient(circle at bottom right, transparent 15px, #fffbf2 16px)
          bottom right;
      background-size: 51% 51%;
      background-repeat: no-repeat;
    }
    .textBox {
      // width: 43%;
    }
    .text {
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
      margin-top: 1rem;
      height: calc(100vh - $head-height - 12rem);
      height: 25vh;
      padding-bottom: 3rem;
      ::v-deep p {
        border-bottom: 1px solid $ccc-gold;
      }
    }
    .node {
      // width: 53%;
      margin-top: 0.4rem;
      .nodeTitle {
        font-size: $f-mid;
        color: $ccc-gold;
        border-bottom: 1px solid $ccc-gold;
        text-align: left;
        padding: 0.4rem 0.6rem;
      }
      .nodeText {
        overflow: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        height: calc(100vh - $head-height - 12rem);
        height: 49vh;
        padding-bottom: 3rem;
        ::v-deep b {
          color: $ccc-gold;
        }
      }
    }
  }
}
</style>